import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _40b0075c = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _e57ad8bc = () => interopDefault(import('../pages/activity/index.vue' /* webpackChunkName: "pages/activity/index" */))
const _150e4358 = () => interopDefault(import('../pages/activityTech/index.vue' /* webpackChunkName: "pages/activityTech/index" */))
const _376d3f5c = () => interopDefault(import('../pages/antincp/index.vue' /* webpackChunkName: "pages/antincp/index" */))
const _106690ba = () => interopDefault(import('../pages/assetSingleChengguo/index.vue' /* webpackChunkName: "pages/assetSingleChengguo/index" */))
const _3f0e9374 = () => interopDefault(import('../pages/bearer/index.vue' /* webpackChunkName: "pages/bearer/index" */))
const _63d4a33d = () => interopDefault(import('../pages/bearerJS/index.vue' /* webpackChunkName: "pages/bearerJS/index" */))
const _39b16fe0 = () => interopDefault(import('../pages/bearerNj/index.vue' /* webpackChunkName: "pages/bearerNj/index" */))
const _1adc9add = () => interopDefault(import('../pages/bid2021/index.vue' /* webpackChunkName: "pages/bid2021/index" */))
const _a07d64c4 = () => interopDefault(import('../pages/bid2022/index.vue' /* webpackChunkName: "pages/bid2022/index" */))
const _107d3403 = () => interopDefault(import('../pages/bid2022-real/index.vue' /* webpackChunkName: "pages/bid2022-real/index" */))
const _1be1dc3c = () => interopDefault(import('../pages/bid2023-real/index.vue' /* webpackChunkName: "pages/bid2023-real/index" */))
const _37af4f13 = () => interopDefault(import('../pages/bindAccount/index.vue' /* webpackChunkName: "pages/bindAccount/index" */))
const _34d49875 = () => interopDefault(import('../pages/branch/index.vue' /* webpackChunkName: "pages/branch/index" */))
const _75e9bb68 = () => interopDefault(import('../pages/center/index.vue' /* webpackChunkName: "pages/center/index" */))
const _b9c9e944 = () => interopDefault(import('../pages/chatOnline/index.vue' /* webpackChunkName: "pages/chatOnline/index" */))
const _312ede8c = () => interopDefault(import('../pages/college/index.vue' /* webpackChunkName: "pages/college/index" */))
const _d6da2bae = () => interopDefault(import('../pages/collegeActivity/index.vue' /* webpackChunkName: "pages/collegeActivity/index" */))
const _5882e422 = () => interopDefault(import('../pages/collegeChengguo/index.vue' /* webpackChunkName: "pages/collegeChengguo/index" */))
const _0c3b1f79 = () => interopDefault(import('../pages/collegeHome/index.vue' /* webpackChunkName: "pages/collegeHome/index" */))
const _379f0f10 = () => interopDefault(import('../pages/collegeList/index.vue' /* webpackChunkName: "pages/collegeList/index" */))
const _4609f342 = () => interopDefault(import('../pages/collegeMien/index.vue' /* webpackChunkName: "pages/collegeMien/index" */))
const _099392c8 = () => interopDefault(import('../pages/collegeNew/index.vue' /* webpackChunkName: "pages/collegeNew/index" */))
const _77c1d46d = () => interopDefault(import('../pages/collegeNews/index.vue' /* webpackChunkName: "pages/collegeNews/index" */))
const _441e5542 = () => interopDefault(import('../pages/collegeSearch/index.vue' /* webpackChunkName: "pages/collegeSearch/index" */))
const _279f1d68 = () => interopDefault(import('../pages/crowdsourcing/index.vue' /* webpackChunkName: "pages/crowdsourcing/index" */))
const _3abd4444 = () => interopDefault(import('../pages/demand/index.vue' /* webpackChunkName: "pages/demand/index" */))
const _af4035a8 = () => interopDefault(import('../pages/demandDashboard/index.vue' /* webpackChunkName: "pages/demandDashboard/index" */))
const _1c152210 = () => interopDefault(import('../pages/demandListV2/index.vue' /* webpackChunkName: "pages/demandListV2/index" */))
const _30d96d33 = () => interopDefault(import('../pages/demo.vue' /* webpackChunkName: "pages/demo" */))
const _f37de2a2 = () => interopDefault(import('../pages/dqxqLb/index.vue' /* webpackChunkName: "pages/dqxqLb/index" */))
const _24544854 = () => interopDefault(import('../pages/ecoBlank/index.vue' /* webpackChunkName: "pages/ecoBlank/index" */))
const _00561f9c = () => interopDefault(import('../pages/ecoServices/index.vue' /* webpackChunkName: "pages/ecoServices/index" */))
const _3c3356fd = () => interopDefault(import('../pages/expert/index.vue' /* webpackChunkName: "pages/expert/index" */))
const _5a027186 = () => interopDefault(import('../pages/finance/index.vue' /* webpackChunkName: "pages/finance/index" */))
const _24562f62 = () => interopDefault(import('../pages/firmList/index.vue' /* webpackChunkName: "pages/firmList/index" */))
const _3813e013 = () => interopDefault(import('../pages/forgetpwd/index.vue' /* webpackChunkName: "pages/forgetpwd/index" */))
const _4d4bf0ca = () => interopDefault(import('../pages/gnyz/index.vue' /* webpackChunkName: "pages/gnyz/index" */))
const _459375b9 = () => interopDefault(import('../pages/goods/index.vue' /* webpackChunkName: "pages/goods/index" */))
const _1616632e = () => interopDefault(import('../pages/goods1/index.vue' /* webpackChunkName: "pages/goods1/index" */))
const _70a212da = () => interopDefault(import('../pages/goodsListV2/index.vue' /* webpackChunkName: "pages/goodsListV2/index" */))
const _23a83554 = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _ebfffcfc = () => interopDefault(import('../pages/Intermediary/index.vue' /* webpackChunkName: "pages/Intermediary/index" */))
const _0fb3cb84 = () => interopDefault(import('../pages/jtop/index.vue' /* webpackChunkName: "pages/jtop/index" */))
const _2ec6250a = () => interopDefault(import('../pages/jtop2021/index.vue' /* webpackChunkName: "pages/jtop2021/index" */))
const _3527d2f0 = () => interopDefault(import('../pages/jtopTest/index.vue' /* webpackChunkName: "pages/jtopTest/index" */))
const _06d56546 = () => interopDefault(import('../pages/laboratory/index.vue' /* webpackChunkName: "pages/laboratory/index" */))
const _104b5ad0 = () => interopDefault(import('../pages/listed/index.vue' /* webpackChunkName: "pages/listed/index" */))
const _5e75dbe8 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _8342595e = () => interopDefault(import('../pages/loginThird/index.vue' /* webpackChunkName: "pages/loginThird/index" */))
const _a0a55d94 = () => interopDefault(import('../pages/manageList/index.vue' /* webpackChunkName: "pages/manageList/index" */))
const _fba9bb34 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _593c8c45 = () => interopDefault(import('../pages/onlineService/index.vue' /* webpackChunkName: "pages/onlineService/index" */))
const _74ca7276 = () => interopDefault(import('../pages/points/index.vue' /* webpackChunkName: "pages/points/index" */))
const _7ae79918 = () => interopDefault(import('../pages/presentationDemand/index.vue' /* webpackChunkName: "pages/presentationDemand/index" */))
const _3b2e4548 = () => interopDefault(import('../pages/publicity/index.vue' /* webpackChunkName: "pages/publicity/index" */))
const _47873394 = () => interopDefault(import('../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _5670f987 = () => interopDefault(import('../pages/report/index.vue' /* webpackChunkName: "pages/report/index" */))
const _74cd87dd = () => interopDefault(import('../pages/rmxqLb/index.vue' /* webpackChunkName: "pages/rmxqLb/index" */))
const _78958560 = () => interopDefault(import('../pages/roadShow/index.vue' /* webpackChunkName: "pages/roadShow/index" */))
const _596c08fb = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _7a32684c = () => interopDefault(import('../pages/serviceGuide/index.vue' /* webpackChunkName: "pages/serviceGuide/index" */))
const _04ee1af1 = () => interopDefault(import('../pages/serviceHall/index.vue' /* webpackChunkName: "pages/serviceHall/index" */))
const _2d94ee74 = () => interopDefault(import('../pages/shop.vue' /* webpackChunkName: "pages/shop" */))
const _8a643a6e = () => interopDefault(import('../pages/shop/index.vue' /* webpackChunkName: "pages/shop/index" */))
const _c1f3c08e = () => interopDefault(import('../pages/shop/index2.vue' /* webpackChunkName: "pages/shop/index2" */))
const _13f2b35e = () => interopDefault(import('../pages/shop/indexCopy.vue' /* webpackChunkName: "pages/shop/indexCopy" */))
const _1c04a197 = () => interopDefault(import('../pages/shop/orgAnalysis.vue' /* webpackChunkName: "pages/shop/orgAnalysis" */))
const _fea33d12 = () => interopDefault(import('../pages/shop/shopGoods.vue' /* webpackChunkName: "pages/shop/shopGoods" */))
const _d595126a = () => interopDefault(import('../pages/shop/shopGoods2.vue' /* webpackChunkName: "pages/shop/shopGoods2" */))
const _3d93395c = () => interopDefault(import('../pages/shop2.vue' /* webpackChunkName: "pages/shop2" */))
const _4c25da4a = () => interopDefault(import('../pages/shopCopy.vue' /* webpackChunkName: "pages/shopCopy" */))
const _360f5892 = () => interopDefault(import('../pages/statement/index.vue' /* webpackChunkName: "pages/statement/index" */))
const _e1ca3e7e = () => interopDefault(import('../pages/stzqLb/index.vue' /* webpackChunkName: "pages/stzqLb/index" */))
const _7e8a1f82 = () => interopDefault(import('../pages/supply/index.vue' /* webpackChunkName: "pages/supply/index" */))
const _08161af6 = () => interopDefault(import('../pages/supply1/index.vue' /* webpackChunkName: "pages/supply1/index" */))
const _455cd2d4 = () => interopDefault(import('../pages/supplyNew/index.vue' /* webpackChunkName: "pages/supplyNew/index" */))
const _3ecaa60b = () => interopDefault(import('../pages/talentZone/index.vue' /* webpackChunkName: "pages/talentZone/index" */))
const _226fc4ec = () => interopDefault(import('../pages/techManageList/index.vue' /* webpackChunkName: "pages/techManageList/index" */))
const _3805eeb0 = () => interopDefault(import('../pages/technicalContractsRegistration/index.vue' /* webpackChunkName: "pages/technicalContractsRegistration/index" */))
const _4025c590 = () => interopDefault(import('../pages/technologicalAchievement/index.vue' /* webpackChunkName: "pages/technologicalAchievement/index" */))
const _437bf965 = () => interopDefault(import('../pages/test/index.vue' /* webpackChunkName: "pages/test/index" */))
const _2d5c089a = () => interopDefault(import('../pages/thirdPartyAuth/index.vue' /* webpackChunkName: "pages/thirdPartyAuth/index" */))
const _355f6a4d = () => interopDefault(import('../pages/transactionScreen/index.vue' /* webpackChunkName: "pages/transactionScreen/index" */))
const _46bb1f78 = () => interopDefault(import('../pages/tzj2021/index.vue' /* webpackChunkName: "pages/tzj2021/index" */))
const _71872305 = () => interopDefault(import('../pages/tzj2022/index.vue' /* webpackChunkName: "pages/tzj2022/index" */))
const _6c50b208 = () => interopDefault(import('../pages/tzj2022-real/index.vue' /* webpackChunkName: "pages/tzj2022-real/index" */))
const _a92cf64a = () => interopDefault(import('../pages/tzj2023-real/index.vue' /* webpackChunkName: "pages/tzj2023-real/index" */))
const _178551d4 = () => interopDefault(import('../pages/xianlin/index.vue' /* webpackChunkName: "pages/xianlin/index" */))
const _2cbf782a = () => interopDefault(import('../pages/xianlinAboutUs/index.vue' /* webpackChunkName: "pages/xianlinAboutUs/index" */))
const _784cd6f6 = () => interopDefault(import('../pages/xianlinActivity/index.vue' /* webpackChunkName: "pages/xianlinActivity/index" */))
const _414c0bf9 = () => interopDefault(import('../pages/xianlinAgencyList/index.vue' /* webpackChunkName: "pages/xianlinAgencyList/index" */))
const _3d02f1fe = () => interopDefault(import('../pages/xianlinGnyz/index.vue' /* webpackChunkName: "pages/xianlinGnyz/index" */))
const _5707d7b6 = () => interopDefault(import('../pages/xianlinGoods/index.vue' /* webpackChunkName: "pages/xianlinGoods/index" */))
const _7eec5306 = () => interopDefault(import('../pages/xianlinJgShop.vue' /* webpackChunkName: "pages/xianlinJgShop" */))
const _d75805ee = () => interopDefault(import('../pages/xianlinJgShop/index.vue' /* webpackChunkName: "pages/xianlinJgShop/index" */))
const _1379650e = () => interopDefault(import('../pages/xianlinJgShop/index2.vue' /* webpackChunkName: "pages/xianlinJgShop/index2" */))
const _2c61ad9e = () => interopDefault(import('../pages/xianlinJgShop/indexCopy.vue' /* webpackChunkName: "pages/xianlinJgShop/indexCopy" */))
const _56c3e852 = () => interopDefault(import('../pages/xianlinJgShop/orgAnalysis.vue' /* webpackChunkName: "pages/xianlinJgShop/orgAnalysis" */))
const _cdc54892 = () => interopDefault(import('../pages/xianlinJgShop/shopGoods.vue' /* webpackChunkName: "pages/xianlinJgShop/shopGoods" */))
const _eab476ea = () => interopDefault(import('../pages/xianlinJgShop/shopGoods2.vue' /* webpackChunkName: "pages/xianlinJgShop/shopGoods2" */))
const _5242b0d4 = () => interopDefault(import('../pages/xianlinList/index.vue' /* webpackChunkName: "pages/xianlinList/index" */))
const _c6f0b54e = () => interopDefault(import('../pages/xianlinManageList/index.vue' /* webpackChunkName: "pages/xianlinManageList/index" */))
const _3457e66e = () => interopDefault(import('../pages/xianlinNews/index.vue' /* webpackChunkName: "pages/xianlinNews/index" */))
const _33695bce = () => interopDefault(import('../pages/xianlinNotice/index.vue' /* webpackChunkName: "pages/xianlinNotice/index" */))
const _b0edcb8a = () => interopDefault(import('../pages/xianlinPresentationDemand/index.vue' /* webpackChunkName: "pages/xianlinPresentationDemand/index" */))
const _4f36a474 = () => interopDefault(import('../pages/xianlinPtzt/index.vue' /* webpackChunkName: "pages/xianlinPtzt/index" */))
const _2819301a = () => interopDefault(import('../pages/xianlinRAndDInstitutions/index.vue' /* webpackChunkName: "pages/xianlinRAndDInstitutions/index" */))
const _4eeab969 = () => interopDefault(import('../pages/xianlinShop.vue' /* webpackChunkName: "pages/xianlinShop" */))
const _1e76cd2c = () => interopDefault(import('../pages/xianlinShop/index.vue' /* webpackChunkName: "pages/xianlinShop/index" */))
const _08def5ba = () => interopDefault(import('../pages/xianlinShop/orgAnalysis.vue' /* webpackChunkName: "pages/xianlinShop/orgAnalysis" */))
const _91753b4c = () => interopDefault(import('../pages/xianlinShop/shopGoods.vue' /* webpackChunkName: "pages/xianlinShop/shopGoods" */))
const _2146bf1a = () => interopDefault(import('../pages/xianlinTechnologicalAchievement/index.vue' /* webpackChunkName: "pages/xianlinTechnologicalAchievement/index" */))
const _35dd2c7f = () => interopDefault(import('../pages/xianlinYqgx/index.vue' /* webpackChunkName: "pages/xianlinYqgx/index" */))
const _7b631ce8 = () => interopDefault(import('../pages/yangzhou/index.vue' /* webpackChunkName: "pages/yangzhou/index" */))
const _c0e52f52 = () => interopDefault(import('../pages/yangzhouActivity/index.vue' /* webpackChunkName: "pages/yangzhouActivity/index" */))
const _014b996a = () => interopDefault(import('../pages/yangzhouAgencyList/index.vue' /* webpackChunkName: "pages/yangzhouAgencyList/index" */))
const _100ee524 = () => interopDefault(import('../pages/yangzhouGoods/index.vue' /* webpackChunkName: "pages/yangzhouGoods/index" */))
const _061218d8 = () => interopDefault(import('../pages/yangzhouJgShop.vue' /* webpackChunkName: "pages/yangzhouJgShop" */))
const _07a2c54a = () => interopDefault(import('../pages/yangzhouJgShop/index.vue' /* webpackChunkName: "pages/yangzhouJgShop/index" */))
const _ec869132 = () => interopDefault(import('../pages/yangzhouJgShop/index2.vue' /* webpackChunkName: "pages/yangzhouJgShop/index2" */))
const _2b205620 = () => interopDefault(import('../pages/yangzhouJgShop/indexCopy.vue' /* webpackChunkName: "pages/yangzhouJgShop/indexCopy" */))
const _47bfa6a9 = () => interopDefault(import('../pages/yangzhouJgShop/orgAnalysis.vue' /* webpackChunkName: "pages/yangzhouJgShop/orgAnalysis" */))
const _572b8309 = () => interopDefault(import('../pages/yangzhouJgShop/shopGoods.vue' /* webpackChunkName: "pages/yangzhouJgShop/shopGoods" */))
const _e346f10e = () => interopDefault(import('../pages/yangzhouJgShop/shopGoods2.vue' /* webpackChunkName: "pages/yangzhouJgShop/shopGoods2" */))
const _5a95ccab = () => interopDefault(import('../pages/yangzhouManageList/index.vue' /* webpackChunkName: "pages/yangzhouManageList/index" */))
const _361e999b = () => interopDefault(import('../pages/yangzhouNews/index.vue' /* webpackChunkName: "pages/yangzhouNews/index" */))
const _626bcf8d = () => interopDefault(import('../pages/yangzhouPresentationDemand/index.vue' /* webpackChunkName: "pages/yangzhouPresentationDemand/index" */))
const _32629045 = () => interopDefault(import('../pages/yangzhouTechnologicalAchievement/index.vue' /* webpackChunkName: "pages/yangzhouTechnologicalAchievement/index" */))
const _46e7a2e4 = () => interopDefault(import('../pages/yrd/index.vue' /* webpackChunkName: "pages/yrd/index" */))
const _59db5840 = () => interopDefault(import('../pages/yrd-jtop/index.vue' /* webpackChunkName: "pages/yrd-jtop/index" */))
const _484059cb = () => interopDefault(import('../pages/yrd2021/index.vue' /* webpackChunkName: "pages/yrd2021/index" */))
const _599a335e = () => interopDefault(import('../pages/yrdgoods/index.vue' /* webpackChunkName: "pages/yrdgoods/index" */))
const _36587b20 = () => interopDefault(import('../pages/zdlyLb/index.vue' /* webpackChunkName: "pages/zdlyLb/index" */))
const _5a97f4e0 = () => interopDefault(import('../pages/achievement/achievementDetail.vue' /* webpackChunkName: "pages/achievement/achievementDetail" */))
const _92485f26 = () => interopDefault(import('../pages/achievement/achievementList.vue' /* webpackChunkName: "pages/achievement/achievementList" */))
const _0476d2b4 = () => interopDefault(import('../pages/achievement/components/index.js' /* webpackChunkName: "pages/achievement/components/index" */))
const _34c530a0 = () => interopDefault(import('../pages/activity/activityDetail.vue' /* webpackChunkName: "pages/activity/activityDetail" */))
const _2d55367b = () => interopDefault(import('../pages/activityTech/data.js' /* webpackChunkName: "pages/activityTech/data" */))
const _a376d4ce = () => interopDefault(import('../pages/activityTech/demandNewList.vue' /* webpackChunkName: "pages/activityTech/demandNewList" */))
const _bce9bd06 = () => interopDefault(import('../pages/activityTech/technicalManager/index.vue' /* webpackChunkName: "pages/activityTech/technicalManager/index" */))
const _d469ac28 = () => interopDefault(import('../pages/bearer/list.vue' /* webpackChunkName: "pages/bearer/list" */))
const _7bda1163 = () => interopDefault(import('../pages/bid2021/list.vue' /* webpackChunkName: "pages/bid2021/list" */))
const _b6628906 = () => interopDefault(import('../pages/bid2022-real/list.vue' /* webpackChunkName: "pages/bid2022-real/list" */))
const _70238282 = () => interopDefault(import('../pages/bid2022/list.vue' /* webpackChunkName: "pages/bid2022/list" */))
const _02abb484 = () => interopDefault(import('../pages/bid2023-real/list.vue' /* webpackChunkName: "pages/bid2023-real/list" */))
const _5bcde50c = () => interopDefault(import('../pages/branch/businessIncubation/index.vue' /* webpackChunkName: "pages/branch/businessIncubation/index" */))
const _3255fd0c = () => interopDefault(import('../pages/branch/changzhou.vue' /* webpackChunkName: "pages/branch/changzhou" */))
const _6c0afd43 = () => interopDefault(import('../pages/branch/devSearch/index.vue' /* webpackChunkName: "pages/branch/devSearch/index" */))
const _5c8edf03 = () => interopDefault(import('../pages/branch/news/index.vue' /* webpackChunkName: "pages/branch/news/index" */))
const _709a5412 = () => interopDefault(import('../pages/branch/policyAdvice.vue' /* webpackChunkName: "pages/branch/policyAdvice" */))
const _c902129a = () => interopDefault(import('../pages/branch/scienceTechnology.vue' /* webpackChunkName: "pages/branch/scienceTechnology" */))
const _57faf672 = () => interopDefault(import('../pages/branch/technicalAchievements/index.vue' /* webpackChunkName: "pages/branch/technicalAchievements/index" */))
const _65f0d92e = () => interopDefault(import('../pages/branch/technicalDemand/index.vue' /* webpackChunkName: "pages/branch/technicalDemand/index" */))
const _09bfec00 = () => interopDefault(import('../pages/branch/technicalManager/index.vue' /* webpackChunkName: "pages/branch/technicalManager/index" */))
const _7d8f5a12 = () => interopDefault(import('../pages/branch/technologyConsulting/index.vue' /* webpackChunkName: "pages/branch/technologyConsulting/index" */))
const _1c99cff8 = () => interopDefault(import('../pages/branch/technologyTransfer.vue' /* webpackChunkName: "pages/branch/technologyTransfer" */))
const _7cb32f28 = () => interopDefault(import('../pages/branch/technologyTransferAgency/index.vue' /* webpackChunkName: "pages/branch/technologyTransferAgency/index" */))
const _9c3f6ffe = () => interopDefault(import('../pages/chatOnline/data.js' /* webpackChunkName: "pages/chatOnline/data" */))
const _464061c6 = () => interopDefault(import('../pages/chatOnline/drawMixin.js' /* webpackChunkName: "pages/chatOnline/drawMixin" */))
const _ab323320 = () => interopDefault(import('../pages/chatOnline/featureListNew.vue' /* webpackChunkName: "pages/chatOnline/featureListNew" */))
const _5a6dfc70 = () => interopDefault(import('../pages/collegeNew/components/index.js' /* webpackChunkName: "pages/collegeNew/components/index" */))
const _ceadaa82 = () => interopDefault(import('../pages/collegeNew/data.js' /* webpackChunkName: "pages/collegeNew/data" */))
const _4775548b = () => interopDefault(import('../pages/crowdsourcing/data.js' /* webpackChunkName: "pages/crowdsourcing/data" */))
const _2e922a56 = () => interopDefault(import('../pages/crowdsourcing/demandDetail.vue' /* webpackChunkName: "pages/crowdsourcing/demandDetail" */))
const _6bb0eb63 = () => interopDefault(import('../pages/crowdsourcing/demandList.vue' /* webpackChunkName: "pages/crowdsourcing/demandList" */))
const _1f939202 = () => interopDefault(import('../pages/crowdsourcing/resolve.vue' /* webpackChunkName: "pages/crowdsourcing/resolve" */))
const _635c7624 = () => interopDefault(import('../pages/demandDashboard/dashboard.vue' /* webpackChunkName: "pages/demandDashboard/dashboard" */))
const _68ef6fa0 = () => interopDefault(import('../pages/finance/data.js' /* webpackChunkName: "pages/finance/data" */))
const _252d2ff6 = () => interopDefault(import('../pages/finance/detail.vue' /* webpackChunkName: "pages/finance/detail" */))
const _651b3124 = () => interopDefault(import('../pages/firmList/detail.vue' /* webpackChunkName: "pages/firmList/detail" */))
const _14f3533d = () => interopDefault(import('../pages/gnyz/shop.vue' /* webpackChunkName: "pages/gnyz/shop" */))
const _44d1a952 = () => interopDefault(import('../pages/gnyz/verificationCenter.vue' /* webpackChunkName: "pages/gnyz/verificationCenter" */))
const _2b9fc216 = () => interopDefault(import('../pages/help/searchResult/index.vue' /* webpackChunkName: "pages/help/searchResult/index" */))
const _d7a22014 = () => interopDefault(import('../pages/help/Sec/index.vue' /* webpackChunkName: "pages/help/Sec/index" */))
const _5d6aea32 = () => interopDefault(import('../pages/help/SecDetail/index.vue' /* webpackChunkName: "pages/help/SecDetail/index" */))
const _07084054 = () => interopDefault(import('../pages/Intermediary/components/index.js' /* webpackChunkName: "pages/Intermediary/components/index" */))
const _4842b1c1 = () => interopDefault(import('../pages/Intermediary/enumCode.js' /* webpackChunkName: "pages/Intermediary/enumCode" */))
const _17a2a1e2 = () => interopDefault(import('../pages/jtop/list.vue' /* webpackChunkName: "pages/jtop/list" */))
const _34d419f6 = () => interopDefault(import('../pages/jtop2021/list.vue' /* webpackChunkName: "pages/jtop2021/list" */))
const _2fe3ea20 = () => interopDefault(import('../pages/jtopTest/list.vue' /* webpackChunkName: "pages/jtopTest/list" */))
const _0fd9d5da = () => interopDefault(import('../pages/laboratory/list.vue' /* webpackChunkName: "pages/laboratory/list" */))
const _4c799be4 = () => interopDefault(import('../pages/lasaDemand/data.js' /* webpackChunkName: "pages/lasaDemand/data" */))
const _0ae75dea = () => interopDefault(import('../pages/lasaDemand/demandList.vue' /* webpackChunkName: "pages/lasaDemand/demandList" */))
const _7cbc0bc2 = () => interopDefault(import('../pages/lasaDemand/demandNewList.vue' /* webpackChunkName: "pages/lasaDemand/demandNewList" */))
const _ffdbd37a = () => interopDefault(import('../pages/lasaDemand/goodsList.vue' /* webpackChunkName: "pages/lasaDemand/goodsList" */))
const _89c71e00 = () => interopDefault(import('../pages/lasaDemand/home.vue' /* webpackChunkName: "pages/lasaDemand/home" */))
const _01b4abf0 = () => interopDefault(import('../pages/measurement/anli/index.vue' /* webpackChunkName: "pages/measurement/anli/index" */))
const _9c01f570 = () => interopDefault(import('../pages/measurement/carrier/index.vue' /* webpackChunkName: "pages/measurement/carrier/index" */))
const _50d818f0 = () => interopDefault(import('../pages/measurement/expert/index.vue' /* webpackChunkName: "pages/measurement/expert/index" */))
const _ffba29bc = () => interopDefault(import('../pages/measurement/home.vue' /* webpackChunkName: "pages/measurement/home" */))
const _f75bbb00 = () => interopDefault(import('../pages/measurement/home2.vue' /* webpackChunkName: "pages/measurement/home2" */))
const _0a05ffce = () => interopDefault(import('../pages/measurement/news1/index.vue' /* webpackChunkName: "pages/measurement/news1/index" */))
const _c22a9ae2 = () => interopDefault(import('../pages/measurement/news2/index.vue' /* webpackChunkName: "pages/measurement/news2/index" */))
const _ebf46fc6 = () => interopDefault(import('../pages/measurement/questions/index.vue' /* webpackChunkName: "pages/measurement/questions/index" */))
const _426eddce = () => interopDefault(import('../pages/news/catagory/index.vue' /* webpackChunkName: "pages/news/catagory/index" */))
const _14099bb9 = () => interopDefault(import('../pages/onlineService/analysis.vue' /* webpackChunkName: "pages/onlineService/analysis" */))
const _d08a7232 = () => interopDefault(import('../pages/onlineService/featureList.vue' /* webpackChunkName: "pages/onlineService/featureList" */))
const _703a7969 = () => interopDefault(import('../pages/onlineService/featureListNew.vue' /* webpackChunkName: "pages/onlineService/featureListNew" */))
const _2422e32a = () => interopDefault(import('../pages/onlineService/utils.js' /* webpackChunkName: "pages/onlineService/utils" */))
const _3ef11913 = () => interopDefault(import('../pages/overall/data.js' /* webpackChunkName: "pages/overall/data" */))
const _8c5f044a = () => interopDefault(import('../pages/overall/demandList.vue' /* webpackChunkName: "pages/overall/demandList" */))
const _07b81a31 = () => interopDefault(import('../pages/overall/demandNewList.vue' /* webpackChunkName: "pages/overall/demandNewList" */))
const _47f7f862 = () => interopDefault(import('../pages/overall/demandPublish.vue' /* webpackChunkName: "pages/overall/demandPublish" */))
const _179499b1 = () => interopDefault(import('../pages/overall/home.vue' /* webpackChunkName: "pages/overall/home" */))
const _94d2db68 = () => interopDefault(import('../pages/points/pointsGood.vue' /* webpackChunkName: "pages/points/pointsGood" */))
const _d31ee762 = () => interopDefault(import('../pages/points/pointsOrder.vue' /* webpackChunkName: "pages/points/pointsOrder" */))
const _38f91220 = () => interopDefault(import('../pages/points/pointsRecord.vue' /* webpackChunkName: "pages/points/pointsRecord" */))
const _30d751bf = () => interopDefault(import('../pages/screen/demoData.js' /* webpackChunkName: "pages/screen/demoData" */))
const _04423276 = () => interopDefault(import('../pages/screen/drawMixin.js' /* webpackChunkName: "pages/screen/drawMixin" */))
const _27c0f79c = () => interopDefault(import('../pages/screen/screendq.vue' /* webpackChunkName: "pages/screen/screendq" */))
const _2d422600 = () => interopDefault(import('../pages/screen/screengx.vue' /* webpackChunkName: "pages/screen/screengx" */))
const _35d8789c = () => interopDefault(import('../pages/screen/screenly.vue' /* webpackChunkName: "pages/screen/screenly" */))
const _4b96bca7 = () => interopDefault(import('../pages/screen/screenyq.vue' /* webpackChunkName: "pages/screen/screenyq" */))
const _4c159030 = () => interopDefault(import('../pages/screen/screenyz.vue' /* webpackChunkName: "pages/screen/screenyz" */))
const _52dc4af9 = () => interopDefault(import('../pages/serviceHall/coreToolDetail.vue' /* webpackChunkName: "pages/serviceHall/coreToolDetail" */))
const _e36fbf58 = () => interopDefault(import('../pages/serviceHall/data.js' /* webpackChunkName: "pages/serviceHall/data" */))
const _9f9b7ef6 = () => interopDefault(import('../pages/serviceHall/serviceDetail.vue' /* webpackChunkName: "pages/serviceHall/serviceDetail" */))
const _6d647a46 = () => interopDefault(import('../pages/sold/demand.vue' /* webpackChunkName: "pages/sold/demand" */))
const _9c5168aa = () => interopDefault(import('../pages/sold/goods.vue' /* webpackChunkName: "pages/sold/goods" */))
const _c7ee9ab0 = () => interopDefault(import('../pages/supplyNew/components/index.js' /* webpackChunkName: "pages/supplyNew/components/index" */))
const _348d1612 = () => interopDefault(import('../pages/supplyNew/data.js' /* webpackChunkName: "pages/supplyNew/data" */))
const _47beac24 = () => interopDefault(import('../pages/talentZone/data.js' /* webpackChunkName: "pages/talentZone/data" */))
const _32dd2ae8 = () => interopDefault(import('../pages/talentZone/detail.vue' /* webpackChunkName: "pages/talentZone/detail" */))
const _78482fb2 = () => interopDefault(import('../pages/techManageList/detail.vue' /* webpackChunkName: "pages/techManageList/detail" */))
const _0560f952 = () => interopDefault(import('../pages/thirdPartyAuth/sso.vue' /* webpackChunkName: "pages/thirdPartyAuth/sso" */))
const _eeb82f12 = () => interopDefault(import('../pages/transactionScreen/drawMixin.js' /* webpackChunkName: "pages/transactionScreen/drawMixin" */))
const _18df507c = () => interopDefault(import('../pages/transactionScreen/drawMixin copy.js' /* webpackChunkName: "pages/transactionScreen/drawMixin copy" */))
const _764f2171 = () => interopDefault(import('../pages/tzj2022-real/dqlist.vue' /* webpackChunkName: "pages/tzj2022-real/dqlist" */))
const _8a83bb1e = () => interopDefault(import('../pages/tzj2022-real/lylist.vue' /* webpackChunkName: "pages/tzj2022-real/lylist" */))
const _fd7cd5c2 = () => interopDefault(import('../pages/tzj2022-real/rmlist.vue' /* webpackChunkName: "pages/tzj2022-real/rmlist" */))
const _f92be176 = () => interopDefault(import('../pages/tzj2022-real/stlist.vue' /* webpackChunkName: "pages/tzj2022-real/stlist" */))
const _76e1b2f0 = () => interopDefault(import('../pages/tzj2022/dqlist.vue' /* webpackChunkName: "pages/tzj2022/dqlist" */))
const _08fe2788 = () => interopDefault(import('../pages/tzj2022/lylist.vue' /* webpackChunkName: "pages/tzj2022/lylist" */))
const _60fccb94 = () => interopDefault(import('../pages/tzj2022/rmlist.vue' /* webpackChunkName: "pages/tzj2022/rmlist" */))
const _5cabd748 = () => interopDefault(import('../pages/tzj2022/stlist.vue' /* webpackChunkName: "pages/tzj2022/stlist" */))
const _720e011c = () => interopDefault(import('../pages/tzj2023-real/dqlist.vue' /* webpackChunkName: "pages/tzj2023-real/dqlist" */))
const _0b680072 = () => interopDefault(import('../pages/tzj2023-real/lylist.vue' /* webpackChunkName: "pages/tzj2023-real/lylist" */))
const _5c2919c0 = () => interopDefault(import('../pages/tzj2023-real/rmlist.vue' /* webpackChunkName: "pages/tzj2023-real/rmlist" */))
const _57d82574 = () => interopDefault(import('../pages/tzj2023-real/stlist.vue' /* webpackChunkName: "pages/tzj2023-real/stlist" */))
const _586987aa = () => interopDefault(import('../pages/xianlin/serviceDetail.vue' /* webpackChunkName: "pages/xianlin/serviceDetail" */))
const _0a032587 = () => interopDefault(import('../pages/yiliDemand/aboutUs/index.vue' /* webpackChunkName: "pages/yiliDemand/aboutUs/index" */))
const _fb462ed0 = () => interopDefault(import('../pages/yiliDemand/achievementArea/index.vue' /* webpackChunkName: "pages/yiliDemand/achievementArea/index" */))
const _710f486e = () => interopDefault(import('../pages/yiliDemand/data.js' /* webpackChunkName: "pages/yiliDemand/data" */))
const _793fdc5c = () => interopDefault(import('../pages/yiliDemand/demandArea/index.vue' /* webpackChunkName: "pages/yiliDemand/demandArea/index" */))
const _529a1c06 = () => interopDefault(import('../pages/yiliDemand/demandPublish.vue' /* webpackChunkName: "pages/yiliDemand/demandPublish" */))
const _5d91ae90 = () => interopDefault(import('../pages/yiliDemand/highSchool/index.vue' /* webpackChunkName: "pages/yiliDemand/highSchool/index" */))
const _54535afb = () => interopDefault(import('../pages/yiliDemand/homeView.vue' /* webpackChunkName: "pages/yiliDemand/homeView" */))
const _754aa6eb = () => interopDefault(import('../pages/yiliDemand/newsList/index.vue' /* webpackChunkName: "pages/yiliDemand/newsList/index" */))
const _9950a800 = () => interopDefault(import('../pages/yrd-jtop/list.vue' /* webpackChunkName: "pages/yrd-jtop/list" */))
const _1f00c392 = () => interopDefault(import('../pages/yrd/list.vue' /* webpackChunkName: "pages/yrd/list" */))
const _2ea88696 = () => interopDefault(import('../pages/yrd2021/list.vue' /* webpackChunkName: "pages/yrd2021/list" */))
const _4e92367c = () => interopDefault(import('../pages/yrdgoods/list.vue' /* webpackChunkName: "pages/yrdgoods/list" */))
const _213c09e8 = () => interopDefault(import('../pages/yrdgoods/openlist.vue' /* webpackChunkName: "pages/yrdgoods/openlist" */))
const _63664a16 = () => interopDefault(import('../pages/yrdgoods/openlistJs.vue' /* webpackChunkName: "pages/yrdgoods/openlistJs" */))
const _56bd2c30 = () => interopDefault(import('../pages/yrdgoods/openlistNj.vue' /* webpackChunkName: "pages/yrdgoods/openlistNj" */))
const _699fd896 = () => interopDefault(import('../pages/achievement/components/achievementCard.vue' /* webpackChunkName: "pages/achievement/components/achievementCard" */))
const _1a849b78 = () => interopDefault(import('../pages/achievement/components/al-selector.vue' /* webpackChunkName: "pages/achievement/components/al-selector" */))
const _93103644 = () => interopDefault(import('../pages/achievement/components/filter.js' /* webpackChunkName: "pages/achievement/components/filter" */))
const _44ae5d40 = () => interopDefault(import('../pages/achievement/components/firstUseCard.vue' /* webpackChunkName: "pages/achievement/components/firstUseCard" */))
const _dcc12502 = () => interopDefault(import('../pages/achievement/components/kxjsCard.vue' /* webpackChunkName: "pages/achievement/components/kxjsCard" */))
const _c870c654 = () => interopDefault(import('../pages/achievement/components/lyCard.vue' /* webpackChunkName: "pages/achievement/components/lyCard" */))
const _ceca846e = () => interopDefault(import('../pages/activityTech/components/databroad.vue' /* webpackChunkName: "pages/activityTech/components/databroad" */))
const _2ae30e00 = () => interopDefault(import('../pages/branch/businessIncubation/filter.vue' /* webpackChunkName: "pages/branch/businessIncubation/filter" */))
const _f1077e42 = () => interopDefault(import('../pages/branch/devSearch/searchFilter.vue' /* webpackChunkName: "pages/branch/devSearch/searchFilter" */))
const _783a95c8 = () => interopDefault(import('../pages/branch/news/catagory/index.vue' /* webpackChunkName: "pages/branch/news/catagory/index" */))
const _b8b8f152 = () => interopDefault(import('../pages/branch/technologyConsulting/shopDetail.vue' /* webpackChunkName: "pages/branch/technologyConsulting/shopDetail" */))
const _d6a61ecc = () => interopDefault(import('../pages/branch/technologyConsulting/shopDetail/index.vue' /* webpackChunkName: "pages/branch/technologyConsulting/shopDetail/index" */))
const _3297bae4 = () => interopDefault(import('../pages/center/components/myPublish.vue' /* webpackChunkName: "pages/center/components/myPublish" */))
const _a0638436 = () => interopDefault(import('../pages/chatOnline/components/AiChat.vue' /* webpackChunkName: "pages/chatOnline/components/AiChat" */))
const _4da9fad1 = () => interopDefault(import('../pages/chatOnline/components/AllFunctionsNew.vue' /* webpackChunkName: "pages/chatOnline/components/AllFunctionsNew" */))
const _2fbd578f = () => interopDefault(import('../pages/chatOnline/components/Historical.vue' /* webpackChunkName: "pages/chatOnline/components/Historical" */))
const _5df01b71 = () => interopDefault(import('../pages/chatOnline/components/HList.vue' /* webpackChunkName: "pages/chatOnline/components/HList" */))
const _39ee8a7a = () => interopDefault(import('../pages/chatOnline/components/RelatedWords.vue' /* webpackChunkName: "pages/chatOnline/components/RelatedWords" */))
const _04c6f4ec = () => interopDefault(import('../pages/chatOnline/components/RightNav.vue' /* webpackChunkName: "pages/chatOnline/components/RightNav" */))
const _946efd64 = () => interopDefault(import('../pages/chatOnline/components/SearchBox.vue' /* webpackChunkName: "pages/chatOnline/components/SearchBox" */))
const _495c3ab6 = () => interopDefault(import('../pages/chatOnline/components/SmartMatchResults.vue' /* webpackChunkName: "pages/chatOnline/components/SmartMatchResults" */))
const _c2771c0a = () => interopDefault(import('../pages/chatOnline/components/TechnicalManagerNew.vue' /* webpackChunkName: "pages/chatOnline/components/TechnicalManagerNew" */))
const _058192b3 = () => interopDefault(import('../pages/collegeHome/components/myPublish.vue' /* webpackChunkName: "pages/collegeHome/components/myPublish" */))
const _3c7c5ee8 = () => interopDefault(import('../pages/collegeNew/components/achievementCard.vue' /* webpackChunkName: "pages/collegeNew/components/achievementCard" */))
const _22098f58 = () => interopDefault(import('../pages/collegeNew/components/filter.js' /* webpackChunkName: "pages/collegeNew/components/filter" */))
const _0c2cde49 = () => interopDefault(import('../pages/collegeNew/components/kxjsCard.vue' /* webpackChunkName: "pages/collegeNew/components/kxjsCard" */))
const _0944a7ee = () => interopDefault(import('../pages/demandDashboard/components/demandCard.vue' /* webpackChunkName: "pages/demandDashboard/components/demandCard" */))
const _5a3203f8 = () => interopDefault(import('../pages/demandDashboard/components/demandShopCard.vue' /* webpackChunkName: "pages/demandDashboard/components/demandShopCard" */))
const _f2778cbc = () => interopDefault(import('../pages/demandListV2/components/demandFilter.vue' /* webpackChunkName: "pages/demandListV2/components/demandFilter" */))
const _3ff707cf = () => interopDefault(import('../pages/firmList/components/data.js' /* webpackChunkName: "pages/firmList/components/data" */))
const _4326bd0e = () => interopDefault(import('../pages/firmList/components/filter.vue' /* webpackChunkName: "pages/firmList/components/filter" */))
const _367cc7a6 = () => interopDefault(import('../pages/firmList/components/infoRow.vue' /* webpackChunkName: "pages/firmList/components/infoRow" */))
const _a7229c3c = () => interopDefault(import('../pages/firmList/components/provinceSelect.vue' /* webpackChunkName: "pages/firmList/components/provinceSelect" */))
const _79e273ea = () => interopDefault(import('../pages/goodsListV2/components/data.js' /* webpackChunkName: "pages/goodsListV2/components/data" */))
const _a9acf55c = () => interopDefault(import('../pages/goodsListV2/components/filter.vue' /* webpackChunkName: "pages/goodsListV2/components/filter" */))
const _8d75fb50 = () => interopDefault(import('../pages/goodsListV2/components/filterRow.vue' /* webpackChunkName: "pages/goodsListV2/components/filterRow" */))
const _08001d34 = () => interopDefault(import('../pages/Intermediary/components/achievementCard.vue' /* webpackChunkName: "pages/Intermediary/components/achievementCard" */))
const _1ff19c48 = () => interopDefault(import('../pages/Intermediary/components/al-selector.vue' /* webpackChunkName: "pages/Intermediary/components/al-selector" */))
const _e2ac7ca4 = () => interopDefault(import('../pages/Intermediary/components/filter.js' /* webpackChunkName: "pages/Intermediary/components/filter" */))
const _642e9eaf = () => interopDefault(import('../pages/Intermediary/components/kxjsCard.vue' /* webpackChunkName: "pages/Intermediary/components/kxjsCard" */))
const _48406b43 = () => interopDefault(import('../pages/lasaDemand/components/demandCard.vue' /* webpackChunkName: "pages/lasaDemand/components/demandCard" */))
const _78388b4f = () => interopDefault(import('../pages/lasaDemand/components/filter.js' /* webpackChunkName: "pages/lasaDemand/components/filter" */))
const _78ef3524 = () => interopDefault(import('../pages/lasaDemand/components/kxjsCard.vue' /* webpackChunkName: "pages/lasaDemand/components/kxjsCard" */))
const _25f2be6f = () => interopDefault(import('../pages/measurement/baseSheshi/largeYiqi/index.vue' /* webpackChunkName: "pages/measurement/baseSheshi/largeYiqi/index" */))
const _5784b6ee = () => interopDefault(import('../pages/measurement/baseSheshi/shiyanshi/index.vue' /* webpackChunkName: "pages/measurement/baseSheshi/shiyanshi/index" */))
const _43b2082f = () => interopDefault(import('../pages/measurement/chengguo/guifan/index.vue' /* webpackChunkName: "pages/measurement/chengguo/guifan/index" */))
const _ca1feca0 = () => interopDefault(import('../pages/measurement/chengguo/xianjin/index.vue' /* webpackChunkName: "pages/measurement/chengguo/xianjin/index" */))
const _06954101 = () => interopDefault(import('../pages/measurement/components/bodyContent.vue' /* webpackChunkName: "pages/measurement/components/bodyContent" */))
const _71298f14 = () => interopDefault(import('../pages/measurement/components/card.vue' /* webpackChunkName: "pages/measurement/components/card" */))
const _a5bbd9d0 = () => interopDefault(import('../pages/measurement/components/five.vue' /* webpackChunkName: "pages/measurement/components/five" */))
const _2cec60e8 = () => interopDefault(import('../pages/measurement/components/four.vue' /* webpackChunkName: "pages/measurement/components/four" */))
const _ab037666 = () => interopDefault(import('../pages/measurement/components/myPublish.vue' /* webpackChunkName: "pages/measurement/components/myPublish" */))
const _b51fd494 = () => interopDefault(import('../pages/measurement/components/myPublish3.vue' /* webpackChunkName: "pages/measurement/components/myPublish3" */))
const _a13fcd20 = () => interopDefault(import('../pages/measurement/components/one.vue' /* webpackChunkName: "pages/measurement/components/one" */))
const _3b0b29d2 = () => interopDefault(import('../pages/measurement/components/seven.vue' /* webpackChunkName: "pages/measurement/components/seven" */))
const _7b7c89ec = () => interopDefault(import('../pages/measurement/components/six.vue' /* webpackChunkName: "pages/measurement/components/six" */))
const _4b6abfb0 = () => interopDefault(import('../pages/measurement/components/three.vue' /* webpackChunkName: "pages/measurement/components/three" */))
const _70706b54 = () => interopDefault(import('../pages/measurement/components/two.vue' /* webpackChunkName: "pages/measurement/components/two" */))
const _7cf0bf04 = () => interopDefault(import('../pages/measurement/questions/ask.vue' /* webpackChunkName: "pages/measurement/questions/ask" */))
const _102ac768 = () => interopDefault(import('../pages/onlineService/components/AiChat.vue' /* webpackChunkName: "pages/onlineService/components/AiChat" */))
const _2d5e98b4 = () => interopDefault(import('../pages/onlineService/components/AllFunctions.vue' /* webpackChunkName: "pages/onlineService/components/AllFunctions" */))
const _b3b83f6c = () => interopDefault(import('../pages/onlineService/components/AllFunctionsNew.vue' /* webpackChunkName: "pages/onlineService/components/AllFunctionsNew" */))
const _3c262a76 = () => interopDefault(import('../pages/onlineService/components/Historical.vue' /* webpackChunkName: "pages/onlineService/components/Historical" */))
const _05aa57ac = () => interopDefault(import('../pages/onlineService/components/HList.vue' /* webpackChunkName: "pages/onlineService/components/HList" */))
const _78886fea = () => interopDefault(import('../pages/onlineService/components/RelatedWords.vue' /* webpackChunkName: "pages/onlineService/components/RelatedWords" */))
const _917554da = () => interopDefault(import('../pages/onlineService/components/RightNav.vue' /* webpackChunkName: "pages/onlineService/components/RightNav" */))
const _53163587 = () => interopDefault(import('../pages/onlineService/components/SearchBox.vue' /* webpackChunkName: "pages/onlineService/components/SearchBox" */))
const _062f6444 = () => interopDefault(import('../pages/onlineService/components/SmartMatchResults.vue' /* webpackChunkName: "pages/onlineService/components/SmartMatchResults" */))
const _35a29d88 = () => interopDefault(import('../pages/onlineService/components/TechnicalManager.vue' /* webpackChunkName: "pages/onlineService/components/TechnicalManager" */))
const _97261a18 = () => interopDefault(import('../pages/onlineService/components/TechnicalManagerNew.vue' /* webpackChunkName: "pages/onlineService/components/TechnicalManagerNew" */))
const _4d6dd624 = () => interopDefault(import('../pages/onlineService/components/TechnicalManagerNew2.vue' /* webpackChunkName: "pages/onlineService/components/TechnicalManagerNew2" */))
const _1efa9ab2 = () => interopDefault(import('../pages/overall/components/demandCard.vue' /* webpackChunkName: "pages/overall/components/demandCard" */))
const _1d090dd4 = () => interopDefault(import('../pages/roadShow/components/activityCard.vue' /* webpackChunkName: "pages/roadShow/components/activityCard" */))
const _6fca1d30 = () => interopDefault(import('../pages/screen/components/areaTopList.vue' /* webpackChunkName: "pages/screen/components/areaTopList" */))
const _8de1948e = () => interopDefault(import('../pages/screen/components/collegeLeft1.vue' /* webpackChunkName: "pages/screen/components/collegeLeft1" */))
const _8dc5658c = () => interopDefault(import('../pages/screen/components/collegeLeft2.vue' /* webpackChunkName: "pages/screen/components/collegeLeft2" */))
const _8da9368a = () => interopDefault(import('../pages/screen/components/collegeLeft3.vue' /* webpackChunkName: "pages/screen/components/collegeLeft3" */))
const _f6aa79ec = () => interopDefault(import('../pages/screen/components/collegeMid1.vue' /* webpackChunkName: "pages/screen/components/collegeMid1" */))
const _f68e4aea = () => interopDefault(import('../pages/screen/components/collegeMid2.vue' /* webpackChunkName: "pages/screen/components/collegeMid2" */))
const _f6721be8 = () => interopDefault(import('../pages/screen/components/collegeMid3.vue' /* webpackChunkName: "pages/screen/components/collegeMid3" */))
const _59d2e514 = () => interopDefault(import('../pages/screen/components/collegeRight1.vue' /* webpackChunkName: "pages/screen/components/collegeRight1" */))
const _59b6b612 = () => interopDefault(import('../pages/screen/components/collegeRight2.vue' /* webpackChunkName: "pages/screen/components/collegeRight2" */))
const _599a8710 = () => interopDefault(import('../pages/screen/components/collegeRight3.vue' /* webpackChunkName: "pages/screen/components/collegeRight3" */))
const _18889bed = () => interopDefault(import('../pages/screen/components/fieldMid1.vue' /* webpackChunkName: "pages/screen/components/fieldMid1" */))
const _18a4caef = () => interopDefault(import('../pages/screen/components/fieldMid3.vue' /* webpackChunkName: "pages/screen/components/fieldMid3" */))
const _0c8a1fb3 = () => interopDefault(import('../pages/screen/components/itemMap.vue' /* webpackChunkName: "pages/screen/components/itemMap" */))
const _f65cffe2 = () => interopDefault(import('../pages/screen/components/itemMap2.vue' /* webpackChunkName: "pages/screen/components/itemMap2" */))
const _f640d0e0 = () => interopDefault(import('../pages/screen/components/itemMap3.vue' /* webpackChunkName: "pages/screen/components/itemMap3" */))
const _13200838 = () => interopDefault(import('../pages/screen/components/table.vue' /* webpackChunkName: "pages/screen/components/table" */))
const _cd70c6bc = () => interopDefault(import('../pages/screen/components/toolTip.js' /* webpackChunkName: "pages/screen/components/toolTip" */))
const _6d0ba054 = () => interopDefault(import('../pages/screen/components/yzArea.vue' /* webpackChunkName: "pages/screen/components/yzArea" */))
const _73fbcb91 = () => interopDefault(import('../pages/screen/directive/dateTime.js' /* webpackChunkName: "pages/screen/directive/dateTime" */))
const _ae796158 = () => interopDefault(import('../pages/screen/directive/demandArea.js' /* webpackChunkName: "pages/screen/directive/demandArea" */))
const _29c3f970 = () => interopDefault(import('../pages/screen/directive/directives.js' /* webpackChunkName: "pages/screen/directive/directives" */))
const _c05cf772 = () => interopDefault(import('../pages/screen/directive/directivesyz.js' /* webpackChunkName: "pages/screen/directive/directivesyz" */))
const _60f1e013 = () => interopDefault(import('../pages/screen/directive/eight.js' /* webpackChunkName: "pages/screen/directive/eight" */))
const _4799435c = () => interopDefault(import('../pages/screen/directive/first.js' /* webpackChunkName: "pages/screen/directive/first" */))
const _758a28cc = () => interopDefault(import('../pages/screen/directive/five.js' /* webpackChunkName: "pages/screen/directive/five" */))
const _61205eb4 = () => interopDefault(import('../pages/screen/directive/four.js' /* webpackChunkName: "pages/screen/directive/four" */))
const _6bfc099a = () => interopDefault(import('../pages/screen/directive/nine.js' /* webpackChunkName: "pages/screen/directive/nine" */))
const _719f9d58 = () => interopDefault(import('../pages/screen/directive/second.js' /* webpackChunkName: "pages/screen/directive/second" */))
const _551517d5 = () => interopDefault(import('../pages/screen/directive/seven.js' /* webpackChunkName: "pages/screen/directive/seven" */))
const _f03294c0 = () => interopDefault(import('../pages/screen/directive/six.js' /* webpackChunkName: "pages/screen/directive/six" */))
const _ed42b6f6 = () => interopDefault(import('../pages/screen/directive/ten.js' /* webpackChunkName: "pages/screen/directive/ten" */))
const _54d17ca4 = () => interopDefault(import('../pages/screen/directive/three.js' /* webpackChunkName: "pages/screen/directive/three" */))
const _d46836c2 = () => interopDefault(import('../pages/screen/directive/yztotal.js' /* webpackChunkName: "pages/screen/directive/yztotal" */))
const _76558754 = () => interopDefault(import('../pages/supplyNew/components/achievementCard.vue' /* webpackChunkName: "pages/supplyNew/components/achievementCard" */))
const _60414596 = () => interopDefault(import('../pages/supplyNew/components/demandCard.vue' /* webpackChunkName: "pages/supplyNew/components/demandCard" */))
const _3e916dc8 = () => interopDefault(import('../pages/supplyNew/components/filter.js' /* webpackChunkName: "pages/supplyNew/components/filter" */))
const _0edc8efe = () => interopDefault(import('../pages/supplyNew/components/kxjsCard.vue' /* webpackChunkName: "pages/supplyNew/components/kxjsCard" */))
const _75490f5a = () => interopDefault(import('../pages/supplyNew/components/serviceCard.vue' /* webpackChunkName: "pages/supplyNew/components/serviceCard" */))
const _f340e514 = () => interopDefault(import('../pages/xianlin/components/myPublish.vue' /* webpackChunkName: "pages/xianlin/components/myPublish" */))
const _79ff2964 = () => interopDefault(import('../pages/yangzhou/components/myPublish.vue' /* webpackChunkName: "pages/yangzhou/components/myPublish" */))
const _adc86d66 = () => interopDefault(import('../pages/yiliDemand/components/demandCard.vue' /* webpackChunkName: "pages/yiliDemand/components/demandCard" */))
const _1a6de1f6 = () => interopDefault(import('../pages/yiliDemand/components/filter.js' /* webpackChunkName: "pages/yiliDemand/components/filter" */))
const _606e5a64 = () => interopDefault(import('../pages/yiliDemand/components/headerBar.vue' /* webpackChunkName: "pages/yiliDemand/components/headerBar" */))
const _8a508410 = () => interopDefault(import('../pages/yiliDemand/components/kxjsCard.vue' /* webpackChunkName: "pages/yiliDemand/components/kxjsCard" */))
const _32c099bb = () => interopDefault(import('../pages/yiliDemand/newsList/newsDetail.vue' /* webpackChunkName: "pages/yiliDemand/newsList/newsDetail" */))
const _1aa8ded2 = () => interopDefault(import('../pages/measurement/baseSheshi/largeYiqi/_id.vue' /* webpackChunkName: "pages/measurement/baseSheshi/largeYiqi/_id" */))
const _2d0f9cd6 = () => interopDefault(import('../pages/measurement/baseSheshi/shiyanshi/_id.vue' /* webpackChunkName: "pages/measurement/baseSheshi/shiyanshi/_id" */))
const _17324a57 = () => interopDefault(import('../pages/measurement/chengguo/guifan/_id.vue' /* webpackChunkName: "pages/measurement/chengguo/guifan/_id" */))
const _6d54b818 = () => interopDefault(import('../pages/measurement/chengguo/xianjin/_id.vue' /* webpackChunkName: "pages/measurement/chengguo/xianjin/_id" */))
const _339e99eb = () => interopDefault(import('../pages/technicalContractsRegistration/list/detail/_id.vue' /* webpackChunkName: "pages/technicalContractsRegistration/list/detail/_id" */))
const _5b7d5f25 = () => interopDefault(import('../pages/activityTech/technicalManager/_id.vue' /* webpackChunkName: "pages/activityTech/technicalManager/_id" */))
const _ecbfb33c = () => interopDefault(import('../pages/branch/businessIncubation/_id.vue' /* webpackChunkName: "pages/branch/businessIncubation/_id" */))
const _1ca5172a = () => interopDefault(import('../pages/branch/devSearch/_id.vue' /* webpackChunkName: "pages/branch/devSearch/_id" */))
const _fd8273aa = () => interopDefault(import('../pages/branch/news/_id.vue' /* webpackChunkName: "pages/branch/news/_id" */))
const _ebade622 = () => interopDefault(import('../pages/branch/technicalAchievements/_id.vue' /* webpackChunkName: "pages/branch/technicalAchievements/_id" */))
const _abf78994 = () => interopDefault(import('../pages/branch/technicalDemand/_Id.vue' /* webpackChunkName: "pages/branch/technicalDemand/_Id" */))
const _19aee730 = () => interopDefault(import('../pages/branch/technicalManager/_id.vue' /* webpackChunkName: "pages/branch/technicalManager/_id" */))
const _60779758 = () => interopDefault(import('../pages/measurement/expert/_id.vue' /* webpackChunkName: "pages/measurement/expert/_id" */))
const _670d9db6 = () => interopDefault(import('../pages/measurement/news1/_id.vue' /* webpackChunkName: "pages/measurement/news1/_id" */))
const _095be692 = () => interopDefault(import('../pages/measurement/news2/_id.vue' /* webpackChunkName: "pages/measurement/news2/_id" */))
const _fa54a476 = () => interopDefault(import('../pages/technicalContractsRegistration/download/_id.vue' /* webpackChunkName: "pages/technicalContractsRegistration/download/_id" */))
const _12eeacdb = () => interopDefault(import('../pages/technicalContractsRegistration/list/_id.vue' /* webpackChunkName: "pages/technicalContractsRegistration/list/_id" */))
const _31853bc0 = () => interopDefault(import('../pages/activityTech/_id.vue' /* webpackChunkName: "pages/activityTech/_id" */))
const _48bb68c4 = () => interopDefault(import('../pages/antincp/_id.vue' /* webpackChunkName: "pages/antincp/_id" */))
const _3eb7e3d6 = () => interopDefault(import('../pages/collegeNews/_id.vue' /* webpackChunkName: "pages/collegeNews/_id" */))
const _b49616b6 = () => interopDefault(import('../pages/expert/_id.vue' /* webpackChunkName: "pages/expert/_id" */))
const _70e8012e = () => interopDefault(import('../pages/laboratory/_id.vue' /* webpackChunkName: "pages/laboratory/_id" */))
const _50a9a129 = () => interopDefault(import('../pages/lasaDemand/_id.vue' /* webpackChunkName: "pages/lasaDemand/_id" */))
const _41aa291e = () => interopDefault(import('../pages/manageList/_id.vue' /* webpackChunkName: "pages/manageList/_id" */))
const _4a6af364 = () => interopDefault(import('../pages/news/_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _43211e58 = () => interopDefault(import('../pages/overall/_id.vue' /* webpackChunkName: "pages/overall/_id" */))
const _3e9cf9b0 = () => interopDefault(import('../pages/publicity/_id.vue' /* webpackChunkName: "pages/publicity/_id" */))
const _7e7c3f66 = () => interopDefault(import('../pages/xianlinActivity/_Id.vue' /* webpackChunkName: "pages/xianlinActivity/_Id" */))
const _a8d8b67e = () => interopDefault(import('../pages/xianlinAgencyList/_Id.vue' /* webpackChunkName: "pages/xianlinAgencyList/_Id" */))
const _5d336ff4 = () => interopDefault(import('../pages/xianlinGnyz/_Id.vue' /* webpackChunkName: "pages/xianlinGnyz/_Id" */))
const _78412a01 = () => interopDefault(import('../pages/xianlinManageList/_id.vue' /* webpackChunkName: "pages/xianlinManageList/_id" */))
const _0b60ad71 = () => interopDefault(import('../pages/xianlinNews/_id.vue' /* webpackChunkName: "pages/xianlinNews/_id" */))
const _0997f9b6 = () => interopDefault(import('../pages/xianlinNotice/_id.vue' /* webpackChunkName: "pages/xianlinNotice/_id" */))
const _b23948fa = () => interopDefault(import('../pages/xianlinPresentationDemand/_Id.vue' /* webpackChunkName: "pages/xianlinPresentationDemand/_Id" */))
const _0eb01ffc = () => interopDefault(import('../pages/xianlinPtzt/_Id.vue' /* webpackChunkName: "pages/xianlinPtzt/_Id" */))
const _7641a272 = () => interopDefault(import('../pages/xianlinYqgx/_Id.vue' /* webpackChunkName: "pages/xianlinYqgx/_Id" */))
const _289c809f = () => interopDefault(import('../pages/yangzhouActivity/_Id.vue' /* webpackChunkName: "pages/yangzhouActivity/_Id" */))
const _1d59e9f3 = () => interopDefault(import('../pages/yangzhouManageList/_Id.vue' /* webpackChunkName: "pages/yangzhouManageList/_Id" */))
const _602c46c3 = () => interopDefault(import('../pages/yangzhouNews/_id.vue' /* webpackChunkName: "pages/yangzhouNews/_id" */))
const _27373d55 = () => interopDefault(import('../pages/yangzhouPresentationDemand/_Id.vue' /* webpackChunkName: "pages/yangzhouPresentationDemand/_Id" */))
const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _40b0075c,
    name: "achievement"
  }, {
    path: "/activity",
    component: _e57ad8bc,
    name: "activity"
  }, {
    path: "/activityTech",
    component: _150e4358,
    name: "activityTech"
  }, {
    path: "/antincp",
    component: _376d3f5c,
    name: "antincp"
  }, {
    path: "/assetSingleChengguo",
    component: _106690ba,
    name: "assetSingleChengguo"
  }, {
    path: "/bearer",
    component: _3f0e9374,
    name: "bearer"
  }, {
    path: "/bearerJS",
    component: _63d4a33d,
    name: "bearerJS"
  }, {
    path: "/bearerNj",
    component: _39b16fe0,
    name: "bearerNj"
  }, {
    path: "/bid2021",
    component: _1adc9add,
    name: "bid2021"
  }, {
    path: "/bid2022",
    component: _a07d64c4,
    name: "bid2022"
  }, {
    path: "/bid2022-real",
    component: _107d3403,
    name: "bid2022-real"
  }, {
    path: "/bid2023-real",
    component: _1be1dc3c,
    name: "bid2023-real"
  }, {
    path: "/bindAccount",
    component: _37af4f13,
    name: "bindAccount"
  }, {
    path: "/branch",
    component: _34d49875,
    name: "branch"
  }, {
    path: "/center",
    component: _75e9bb68,
    name: "center"
  }, {
    path: "/chatOnline",
    component: _b9c9e944,
    name: "chatOnline"
  }, {
    path: "/college",
    component: _312ede8c,
    name: "college"
  }, {
    path: "/collegeActivity",
    component: _d6da2bae,
    name: "collegeActivity"
  }, {
    path: "/collegeChengguo",
    component: _5882e422,
    name: "collegeChengguo"
  }, {
    path: "/collegeHome",
    component: _0c3b1f79,
    name: "collegeHome"
  }, {
    path: "/collegeList",
    component: _379f0f10,
    name: "collegeList"
  }, {
    path: "/collegeMien",
    component: _4609f342,
    name: "collegeMien"
  }, {
    path: "/collegeNew",
    component: _099392c8,
    name: "collegeNew"
  }, {
    path: "/collegeNews",
    component: _77c1d46d,
    name: "collegeNews"
  }, {
    path: "/collegeSearch",
    component: _441e5542,
    name: "collegeSearch"
  }, {
    path: "/crowdsourcing",
    component: _279f1d68,
    name: "crowdsourcing"
  }, {
    path: "/demand",
    component: _3abd4444,
    name: "demand"
  }, {
    path: "/demandDashboard",
    component: _af4035a8,
    name: "demandDashboard"
  }, {
    path: "/demandListV2",
    component: _1c152210,
    name: "demandListV2"
  }, {
    path: "/demo",
    component: _30d96d33,
    name: "demo"
  }, {
    path: "/dqxqLb",
    component: _f37de2a2,
    name: "dqxqLb"
  }, {
    path: "/ecoBlank",
    component: _24544854,
    name: "ecoBlank"
  }, {
    path: "/ecoServices",
    component: _00561f9c,
    name: "ecoServices"
  }, {
    path: "/expert",
    component: _3c3356fd,
    name: "expert"
  }, {
    path: "/finance",
    component: _5a027186,
    name: "finance"
  }, {
    path: "/firmList",
    component: _24562f62,
    name: "firmList"
  }, {
    path: "/forgetpwd",
    component: _3813e013,
    name: "forgetpwd"
  }, {
    path: "/gnyz",
    component: _4d4bf0ca,
    name: "gnyz"
  }, {
    path: "/goods",
    component: _459375b9,
    name: "goods"
  }, {
    path: "/goods1",
    component: _1616632e,
    name: "goods1"
  }, {
    path: "/goodsListV2",
    component: _70a212da,
    name: "goodsListV2"
  }, {
    path: "/help",
    component: _23a83554,
    name: "help"
  }, {
    path: "/Intermediary",
    component: _ebfffcfc,
    name: "Intermediary"
  }, {
    path: "/jtop",
    component: _0fb3cb84,
    name: "jtop"
  }, {
    path: "/jtop2021",
    component: _2ec6250a,
    name: "jtop2021"
  }, {
    path: "/jtopTest",
    component: _3527d2f0,
    name: "jtopTest"
  }, {
    path: "/laboratory",
    component: _06d56546,
    name: "laboratory"
  }, {
    path: "/listed",
    component: _104b5ad0,
    name: "listed"
  }, {
    path: "/login",
    component: _5e75dbe8,
    name: "login"
  }, {
    path: "/loginThird",
    component: _8342595e,
    name: "loginThird"
  }, {
    path: "/manageList",
    component: _a0a55d94,
    name: "manageList"
  }, {
    path: "/news",
    component: _fba9bb34,
    name: "news"
  }, {
    path: "/onlineService",
    component: _593c8c45,
    name: "onlineService"
  }, {
    path: "/points",
    component: _74ca7276,
    name: "points"
  }, {
    path: "/presentationDemand",
    component: _7ae79918,
    name: "presentationDemand"
  }, {
    path: "/publicity",
    component: _3b2e4548,
    name: "publicity"
  }, {
    path: "/register",
    component: _47873394,
    name: "register"
  }, {
    path: "/report",
    component: _5670f987,
    name: "report"
  }, {
    path: "/rmxqLb",
    component: _74cd87dd,
    name: "rmxqLb"
  }, {
    path: "/roadShow",
    component: _78958560,
    name: "roadShow"
  }, {
    path: "/search",
    component: _596c08fb,
    name: "search"
  }, {
    path: "/serviceGuide",
    component: _7a32684c,
    name: "serviceGuide"
  }, {
    path: "/serviceHall",
    component: _04ee1af1,
    name: "serviceHall"
  }, {
    path: "/shop",
    component: _2d94ee74,
    children: [{
      path: "",
      component: _8a643a6e,
      name: "shop"
    }, {
      path: "index2",
      component: _c1f3c08e,
      name: "shop-index2"
    }, {
      path: "indexCopy",
      component: _13f2b35e,
      name: "shop-indexCopy"
    }, {
      path: "orgAnalysis",
      component: _1c04a197,
      name: "shop-orgAnalysis"
    }, {
      path: "shopGoods",
      component: _fea33d12,
      name: "shop-shopGoods"
    }, {
      path: "shopGoods2",
      component: _d595126a,
      name: "shop-shopGoods2"
    }]
  }, {
    path: "/shop2",
    component: _3d93395c,
    name: "shop2"
  }, {
    path: "/shopCopy",
    component: _4c25da4a,
    name: "shopCopy"
  }, {
    path: "/statement",
    component: _360f5892,
    name: "statement"
  }, {
    path: "/stzqLb",
    component: _e1ca3e7e,
    name: "stzqLb"
  }, {
    path: "/supply",
    component: _7e8a1f82,
    name: "supply"
  }, {
    path: "/supply1",
    component: _08161af6,
    name: "supply1"
  }, {
    path: "/supplyNew",
    component: _455cd2d4,
    name: "supplyNew"
  }, {
    path: "/talentZone",
    component: _3ecaa60b,
    name: "talentZone"
  }, {
    path: "/techManageList",
    component: _226fc4ec,
    name: "techManageList"
  }, {
    path: "/technicalContractsRegistration",
    component: _3805eeb0,
    name: "technicalContractsRegistration"
  }, {
    path: "/technologicalAchievement",
    component: _4025c590,
    name: "technologicalAchievement"
  }, {
    path: "/test",
    component: _437bf965,
    name: "test"
  }, {
    path: "/thirdPartyAuth",
    component: _2d5c089a,
    name: "thirdPartyAuth"
  }, {
    path: "/transactionScreen",
    component: _355f6a4d,
    name: "transactionScreen"
  }, {
    path: "/tzj2021",
    component: _46bb1f78,
    name: "tzj2021"
  }, {
    path: "/tzj2022",
    component: _71872305,
    name: "tzj2022"
  }, {
    path: "/tzj2022-real",
    component: _6c50b208,
    name: "tzj2022-real"
  }, {
    path: "/tzj2023-real",
    component: _a92cf64a,
    name: "tzj2023-real"
  }, {
    path: "/xianlin",
    component: _178551d4,
    name: "xianlin"
  }, {
    path: "/xianlinAboutUs",
    component: _2cbf782a,
    name: "xianlinAboutUs"
  }, {
    path: "/xianlinActivity",
    component: _784cd6f6,
    name: "xianlinActivity"
  }, {
    path: "/xianlinAgencyList",
    component: _414c0bf9,
    name: "xianlinAgencyList"
  }, {
    path: "/xianlinGnyz",
    component: _3d02f1fe,
    name: "xianlinGnyz"
  }, {
    path: "/xianlinGoods",
    component: _5707d7b6,
    name: "xianlinGoods"
  }, {
    path: "/xianlinJgShop",
    component: _7eec5306,
    children: [{
      path: "",
      component: _d75805ee,
      name: "xianlinJgShop"
    }, {
      path: "index2",
      component: _1379650e,
      name: "xianlinJgShop-index2"
    }, {
      path: "indexCopy",
      component: _2c61ad9e,
      name: "xianlinJgShop-indexCopy"
    }, {
      path: "orgAnalysis",
      component: _56c3e852,
      name: "xianlinJgShop-orgAnalysis"
    }, {
      path: "shopGoods",
      component: _cdc54892,
      name: "xianlinJgShop-shopGoods"
    }, {
      path: "shopGoods2",
      component: _eab476ea,
      name: "xianlinJgShop-shopGoods2"
    }]
  }, {
    path: "/xianlinList",
    component: _5242b0d4,
    name: "xianlinList"
  }, {
    path: "/xianlinManageList",
    component: _c6f0b54e,
    name: "xianlinManageList"
  }, {
    path: "/xianlinNews",
    component: _3457e66e,
    name: "xianlinNews"
  }, {
    path: "/xianlinNotice",
    component: _33695bce,
    name: "xianlinNotice"
  }, {
    path: "/xianlinPresentationDemand",
    component: _b0edcb8a,
    name: "xianlinPresentationDemand"
  }, {
    path: "/xianlinPtzt",
    component: _4f36a474,
    name: "xianlinPtzt"
  }, {
    path: "/xianlinRAndDInstitutions",
    component: _2819301a,
    name: "xianlinRAndDInstitutions"
  }, {
    path: "/xianlinShop",
    component: _4eeab969,
    children: [{
      path: "",
      component: _1e76cd2c,
      name: "xianlinShop"
    }, {
      path: "orgAnalysis",
      component: _08def5ba,
      name: "xianlinShop-orgAnalysis"
    }, {
      path: "shopGoods",
      component: _91753b4c,
      name: "xianlinShop-shopGoods"
    }]
  }, {
    path: "/xianlinTechnologicalAchievement",
    component: _2146bf1a,
    name: "xianlinTechnologicalAchievement"
  }, {
    path: "/xianlinYqgx",
    component: _35dd2c7f,
    name: "xianlinYqgx"
  }, {
    path: "/yangzhou",
    component: _7b631ce8,
    name: "yangzhou"
  }, {
    path: "/yangzhouActivity",
    component: _c0e52f52,
    name: "yangzhouActivity"
  }, {
    path: "/yangzhouAgencyList",
    component: _014b996a,
    name: "yangzhouAgencyList"
  }, {
    path: "/yangzhouGoods",
    component: _100ee524,
    name: "yangzhouGoods"
  }, {
    path: "/yangzhouJgShop",
    component: _061218d8,
    children: [{
      path: "",
      component: _07a2c54a,
      name: "yangzhouJgShop"
    }, {
      path: "index2",
      component: _ec869132,
      name: "yangzhouJgShop-index2"
    }, {
      path: "indexCopy",
      component: _2b205620,
      name: "yangzhouJgShop-indexCopy"
    }, {
      path: "orgAnalysis",
      component: _47bfa6a9,
      name: "yangzhouJgShop-orgAnalysis"
    }, {
      path: "shopGoods",
      component: _572b8309,
      name: "yangzhouJgShop-shopGoods"
    }, {
      path: "shopGoods2",
      component: _e346f10e,
      name: "yangzhouJgShop-shopGoods2"
    }]
  }, {
    path: "/yangzhouManageList",
    component: _5a95ccab,
    name: "yangzhouManageList"
  }, {
    path: "/yangzhouNews",
    component: _361e999b,
    name: "yangzhouNews"
  }, {
    path: "/yangzhouPresentationDemand",
    component: _626bcf8d,
    name: "yangzhouPresentationDemand"
  }, {
    path: "/yangzhouTechnologicalAchievement",
    component: _32629045,
    name: "yangzhouTechnologicalAchievement"
  }, {
    path: "/yrd",
    component: _46e7a2e4,
    name: "yrd"
  }, {
    path: "/yrd-jtop",
    component: _59db5840,
    name: "yrd-jtop"
  }, {
    path: "/yrd2021",
    component: _484059cb,
    name: "yrd2021"
  }, {
    path: "/yrdgoods",
    component: _599a335e,
    name: "yrdgoods"
  }, {
    path: "/zdlyLb",
    component: _36587b20,
    name: "zdlyLb"
  }, {
    path: "/achievement/achievementDetail",
    component: _5a97f4e0,
    name: "achievement-achievementDetail"
  }, {
    path: "/achievement/achievementList",
    component: _92485f26,
    name: "achievement-achievementList"
  }, {
    path: "/achievement/components",
    component: _0476d2b4,
    name: "achievement-components"
  }, {
    path: "/activity/activityDetail",
    component: _34c530a0,
    name: "activity-activityDetail"
  }, {
    path: "/activityTech/data",
    component: _2d55367b,
    name: "activityTech-data"
  }, {
    path: "/activityTech/demandNewList",
    component: _a376d4ce,
    name: "activityTech-demandNewList"
  }, {
    path: "/activityTech/technicalManager",
    component: _bce9bd06,
    name: "activityTech-technicalManager"
  }, {
    path: "/bearer/list",
    component: _d469ac28,
    name: "bearer-list"
  }, {
    path: "/bid2021/list",
    component: _7bda1163,
    name: "bid2021-list"
  }, {
    path: "/bid2022-real/list",
    component: _b6628906,
    name: "bid2022-real-list"
  }, {
    path: "/bid2022/list",
    component: _70238282,
    name: "bid2022-list"
  }, {
    path: "/bid2023-real/list",
    component: _02abb484,
    name: "bid2023-real-list"
  }, {
    path: "/branch/businessIncubation",
    component: _5bcde50c,
    name: "branch-businessIncubation"
  }, {
    path: "/branch/changzhou",
    component: _3255fd0c,
    name: "branch-changzhou"
  }, {
    path: "/branch/devSearch",
    component: _6c0afd43,
    name: "branch-devSearch"
  }, {
    path: "/branch/news",
    component: _5c8edf03,
    name: "branch-news"
  }, {
    path: "/branch/policyAdvice",
    component: _709a5412,
    name: "branch-policyAdvice"
  }, {
    path: "/branch/scienceTechnology",
    component: _c902129a,
    name: "branch-scienceTechnology"
  }, {
    path: "/branch/technicalAchievements",
    component: _57faf672,
    name: "branch-technicalAchievements"
  }, {
    path: "/branch/technicalDemand",
    component: _65f0d92e,
    name: "branch-technicalDemand"
  }, {
    path: "/branch/technicalManager",
    component: _09bfec00,
    name: "branch-technicalManager"
  }, {
    path: "/branch/technologyConsulting",
    component: _7d8f5a12,
    name: "branch-technologyConsulting"
  }, {
    path: "/branch/technologyTransfer",
    component: _1c99cff8,
    name: "branch-technologyTransfer"
  }, {
    path: "/branch/technologyTransferAgency",
    component: _7cb32f28,
    name: "branch-technologyTransferAgency"
  }, {
    path: "/chatOnline/data",
    component: _9c3f6ffe,
    name: "chatOnline-data"
  }, {
    path: "/chatOnline/drawMixin",
    component: _464061c6,
    name: "chatOnline-drawMixin"
  }, {
    path: "/chatOnline/featureListNew",
    component: _ab323320,
    name: "chatOnline-featureListNew"
  }, {
    path: "/collegeNew/components",
    component: _5a6dfc70,
    name: "collegeNew-components"
  }, {
    path: "/collegeNew/data",
    component: _ceadaa82,
    name: "collegeNew-data"
  }, {
    path: "/crowdsourcing/data",
    component: _4775548b,
    name: "crowdsourcing-data"
  }, {
    path: "/crowdsourcing/demandDetail",
    component: _2e922a56,
    name: "crowdsourcing-demandDetail"
  }, {
    path: "/crowdsourcing/demandList",
    component: _6bb0eb63,
    name: "crowdsourcing-demandList"
  }, {
    path: "/crowdsourcing/resolve",
    component: _1f939202,
    name: "crowdsourcing-resolve"
  }, {
    path: "/demandDashboard/dashboard",
    component: _635c7624,
    name: "demandDashboard-dashboard"
  }, {
    path: "/finance/data",
    component: _68ef6fa0,
    name: "finance-data"
  }, {
    path: "/finance/detail",
    component: _252d2ff6,
    name: "finance-detail"
  }, {
    path: "/firmList/detail",
    component: _651b3124,
    name: "firmList-detail"
  }, {
    path: "/gnyz/shop",
    component: _14f3533d,
    name: "gnyz-shop"
  }, {
    path: "/gnyz/verificationCenter",
    component: _44d1a952,
    name: "gnyz-verificationCenter"
  }, {
    path: "/help/searchResult",
    component: _2b9fc216,
    name: "help-searchResult"
  }, {
    path: "/help/Sec",
    component: _d7a22014,
    name: "help-Sec"
  }, {
    path: "/help/SecDetail",
    component: _5d6aea32,
    name: "help-SecDetail"
  }, {
    path: "/Intermediary/components",
    component: _07084054,
    name: "Intermediary-components"
  }, {
    path: "/Intermediary/enumCode",
    component: _4842b1c1,
    name: "Intermediary-enumCode"
  }, {
    path: "/jtop/list",
    component: _17a2a1e2,
    name: "jtop-list"
  }, {
    path: "/jtop2021/list",
    component: _34d419f6,
    name: "jtop2021-list"
  }, {
    path: "/jtopTest/list",
    component: _2fe3ea20,
    name: "jtopTest-list"
  }, {
    path: "/laboratory/list",
    component: _0fd9d5da,
    name: "laboratory-list"
  }, {
    path: "/lasaDemand/data",
    component: _4c799be4,
    name: "lasaDemand-data"
  }, {
    path: "/lasaDemand/demandList",
    component: _0ae75dea,
    name: "lasaDemand-demandList"
  }, {
    path: "/lasaDemand/demandNewList",
    component: _7cbc0bc2,
    name: "lasaDemand-demandNewList"
  }, {
    path: "/lasaDemand/goodsList",
    component: _ffdbd37a,
    name: "lasaDemand-goodsList"
  }, {
    path: "/lasaDemand/home",
    component: _89c71e00,
    name: "lasaDemand-home"
  }, {
    path: "/measurement/anli",
    component: _01b4abf0,
    name: "measurement-anli"
  }, {
    path: "/measurement/carrier",
    component: _9c01f570,
    name: "measurement-carrier"
  }, {
    path: "/measurement/expert",
    component: _50d818f0,
    name: "measurement-expert"
  }, {
    path: "/measurement/home",
    component: _ffba29bc,
    name: "measurement-home"
  }, {
    path: "/measurement/home2",
    component: _f75bbb00,
    name: "measurement-home2"
  }, {
    path: "/measurement/news1",
    component: _0a05ffce,
    name: "measurement-news1"
  }, {
    path: "/measurement/news2",
    component: _c22a9ae2,
    name: "measurement-news2"
  }, {
    path: "/measurement/questions",
    component: _ebf46fc6,
    name: "measurement-questions"
  }, {
    path: "/news/catagory",
    component: _426eddce,
    name: "news-catagory"
  }, {
    path: "/onlineService/analysis",
    component: _14099bb9,
    name: "onlineService-analysis"
  }, {
    path: "/onlineService/featureList",
    component: _d08a7232,
    name: "onlineService-featureList"
  }, {
    path: "/onlineService/featureListNew",
    component: _703a7969,
    name: "onlineService-featureListNew"
  }, {
    path: "/onlineService/utils",
    component: _2422e32a,
    name: "onlineService-utils"
  }, {
    path: "/overall/data",
    component: _3ef11913,
    name: "overall-data"
  }, {
    path: "/overall/demandList",
    component: _8c5f044a,
    name: "overall-demandList"
  }, {
    path: "/overall/demandNewList",
    component: _07b81a31,
    name: "overall-demandNewList"
  }, {
    path: "/overall/demandPublish",
    component: _47f7f862,
    name: "overall-demandPublish"
  }, {
    path: "/overall/home",
    component: _179499b1,
    name: "overall-home"
  }, {
    path: "/points/pointsGood",
    component: _94d2db68,
    name: "points-pointsGood"
  }, {
    path: "/points/pointsOrder",
    component: _d31ee762,
    name: "points-pointsOrder"
  }, {
    path: "/points/pointsRecord",
    component: _38f91220,
    name: "points-pointsRecord"
  }, {
    path: "/screen/demoData",
    component: _30d751bf,
    name: "screen-demoData"
  }, {
    path: "/screen/drawMixin",
    component: _04423276,
    name: "screen-drawMixin"
  }, {
    path: "/screen/screendq",
    component: _27c0f79c,
    name: "screen-screendq"
  }, {
    path: "/screen/screengx",
    component: _2d422600,
    name: "screen-screengx"
  }, {
    path: "/screen/screenly",
    component: _35d8789c,
    name: "screen-screenly"
  }, {
    path: "/screen/screenyq",
    component: _4b96bca7,
    name: "screen-screenyq"
  }, {
    path: "/screen/screenyz",
    component: _4c159030,
    name: "screen-screenyz"
  }, {
    path: "/serviceHall/coreToolDetail",
    component: _52dc4af9,
    name: "serviceHall-coreToolDetail"
  }, {
    path: "/serviceHall/data",
    component: _e36fbf58,
    name: "serviceHall-data"
  }, {
    path: "/serviceHall/serviceDetail",
    component: _9f9b7ef6,
    name: "serviceHall-serviceDetail"
  }, {
    path: "/sold/demand",
    component: _6d647a46,
    name: "sold-demand"
  }, {
    path: "/sold/goods",
    component: _9c5168aa,
    name: "sold-goods"
  }, {
    path: "/supplyNew/components",
    component: _c7ee9ab0,
    name: "supplyNew-components"
  }, {
    path: "/supplyNew/data",
    component: _348d1612,
    name: "supplyNew-data"
  }, {
    path: "/talentZone/data",
    component: _47beac24,
    name: "talentZone-data"
  }, {
    path: "/talentZone/detail",
    component: _32dd2ae8,
    name: "talentZone-detail"
  }, {
    path: "/techManageList/detail",
    component: _78482fb2,
    name: "techManageList-detail"
  }, {
    path: "/thirdPartyAuth/sso",
    component: _0560f952,
    name: "thirdPartyAuth-sso"
  }, {
    path: "/transactionScreen/drawMixin",
    component: _eeb82f12,
    name: "transactionScreen-drawMixin"
  }, {
    path: "/transactionScreen/drawMixin copy",
    component: _18df507c,
    name: "transactionScreen-drawMixin copy"
  }, {
    path: "/tzj2022-real/dqlist",
    component: _764f2171,
    name: "tzj2022-real-dqlist"
  }, {
    path: "/tzj2022-real/lylist",
    component: _8a83bb1e,
    name: "tzj2022-real-lylist"
  }, {
    path: "/tzj2022-real/rmlist",
    component: _fd7cd5c2,
    name: "tzj2022-real-rmlist"
  }, {
    path: "/tzj2022-real/stlist",
    component: _f92be176,
    name: "tzj2022-real-stlist"
  }, {
    path: "/tzj2022/dqlist",
    component: _76e1b2f0,
    name: "tzj2022-dqlist"
  }, {
    path: "/tzj2022/lylist",
    component: _08fe2788,
    name: "tzj2022-lylist"
  }, {
    path: "/tzj2022/rmlist",
    component: _60fccb94,
    name: "tzj2022-rmlist"
  }, {
    path: "/tzj2022/stlist",
    component: _5cabd748,
    name: "tzj2022-stlist"
  }, {
    path: "/tzj2023-real/dqlist",
    component: _720e011c,
    name: "tzj2023-real-dqlist"
  }, {
    path: "/tzj2023-real/lylist",
    component: _0b680072,
    name: "tzj2023-real-lylist"
  }, {
    path: "/tzj2023-real/rmlist",
    component: _5c2919c0,
    name: "tzj2023-real-rmlist"
  }, {
    path: "/tzj2023-real/stlist",
    component: _57d82574,
    name: "tzj2023-real-stlist"
  }, {
    path: "/xianlin/serviceDetail",
    component: _586987aa,
    name: "xianlin-serviceDetail"
  }, {
    path: "/yiliDemand/aboutUs",
    component: _0a032587,
    name: "yiliDemand-aboutUs"
  }, {
    path: "/yiliDemand/achievementArea",
    component: _fb462ed0,
    name: "yiliDemand-achievementArea"
  }, {
    path: "/yiliDemand/data",
    component: _710f486e,
    name: "yiliDemand-data"
  }, {
    path: "/yiliDemand/demandArea",
    component: _793fdc5c,
    name: "yiliDemand-demandArea"
  }, {
    path: "/yiliDemand/demandPublish",
    component: _529a1c06,
    name: "yiliDemand-demandPublish"
  }, {
    path: "/yiliDemand/highSchool",
    component: _5d91ae90,
    name: "yiliDemand-highSchool"
  }, {
    path: "/yiliDemand/homeView",
    component: _54535afb,
    name: "yiliDemand-homeView"
  }, {
    path: "/yiliDemand/newsList",
    component: _754aa6eb,
    name: "yiliDemand-newsList"
  }, {
    path: "/yrd-jtop/list",
    component: _9950a800,
    name: "yrd-jtop-list"
  }, {
    path: "/yrd/list",
    component: _1f00c392,
    name: "yrd-list"
  }, {
    path: "/yrd2021/list",
    component: _2ea88696,
    name: "yrd2021-list"
  }, {
    path: "/yrdgoods/list",
    component: _4e92367c,
    name: "yrdgoods-list"
  }, {
    path: "/yrdgoods/openlist",
    component: _213c09e8,
    name: "yrdgoods-openlist"
  }, {
    path: "/yrdgoods/openlistJs",
    component: _63664a16,
    name: "yrdgoods-openlistJs"
  }, {
    path: "/yrdgoods/openlistNj",
    component: _56bd2c30,
    name: "yrdgoods-openlistNj"
  }, {
    path: "/achievement/components/achievementCard",
    component: _699fd896,
    name: "achievement-components-achievementCard"
  }, {
    path: "/achievement/components/al-selector",
    component: _1a849b78,
    name: "achievement-components-al-selector"
  }, {
    path: "/achievement/components/filter",
    component: _93103644,
    name: "achievement-components-filter"
  }, {
    path: "/achievement/components/firstUseCard",
    component: _44ae5d40,
    name: "achievement-components-firstUseCard"
  }, {
    path: "/achievement/components/kxjsCard",
    component: _dcc12502,
    name: "achievement-components-kxjsCard"
  }, {
    path: "/achievement/components/lyCard",
    component: _c870c654,
    name: "achievement-components-lyCard"
  }, {
    path: "/activityTech/components/databroad",
    component: _ceca846e,
    name: "activityTech-components-databroad"
  }, {
    path: "/branch/businessIncubation/filter",
    component: _2ae30e00,
    name: "branch-businessIncubation-filter"
  }, {
    path: "/branch/devSearch/searchFilter",
    component: _f1077e42,
    name: "branch-devSearch-searchFilter"
  }, {
    path: "/branch/news/catagory",
    component: _783a95c8,
    name: "branch-news-catagory"
  }, {
    path: "/branch/technologyConsulting/shopDetail",
    component: _b8b8f152,
    children: [{
      path: "",
      component: _d6a61ecc,
      name: "branch-technologyConsulting-shopDetail"
    }]
  }, {
    path: "/center/components/myPublish",
    component: _3297bae4,
    name: "center-components-myPublish"
  }, {
    path: "/chatOnline/components/AiChat",
    component: _a0638436,
    name: "chatOnline-components-AiChat"
  }, {
    path: "/chatOnline/components/AllFunctionsNew",
    component: _4da9fad1,
    name: "chatOnline-components-AllFunctionsNew"
  }, {
    path: "/chatOnline/components/Historical",
    component: _2fbd578f,
    name: "chatOnline-components-Historical"
  }, {
    path: "/chatOnline/components/HList",
    component: _5df01b71,
    name: "chatOnline-components-HList"
  }, {
    path: "/chatOnline/components/RelatedWords",
    component: _39ee8a7a,
    name: "chatOnline-components-RelatedWords"
  }, {
    path: "/chatOnline/components/RightNav",
    component: _04c6f4ec,
    name: "chatOnline-components-RightNav"
  }, {
    path: "/chatOnline/components/SearchBox",
    component: _946efd64,
    name: "chatOnline-components-SearchBox"
  }, {
    path: "/chatOnline/components/SmartMatchResults",
    component: _495c3ab6,
    name: "chatOnline-components-SmartMatchResults"
  }, {
    path: "/chatOnline/components/TechnicalManagerNew",
    component: _c2771c0a,
    name: "chatOnline-components-TechnicalManagerNew"
  }, {
    path: "/collegeHome/components/myPublish",
    component: _058192b3,
    name: "collegeHome-components-myPublish"
  }, {
    path: "/collegeNew/components/achievementCard",
    component: _3c7c5ee8,
    name: "collegeNew-components-achievementCard"
  }, {
    path: "/collegeNew/components/filter",
    component: _22098f58,
    name: "collegeNew-components-filter"
  }, {
    path: "/collegeNew/components/kxjsCard",
    component: _0c2cde49,
    name: "collegeNew-components-kxjsCard"
  }, {
    path: "/demandDashboard/components/demandCard",
    component: _0944a7ee,
    name: "demandDashboard-components-demandCard"
  }, {
    path: "/demandDashboard/components/demandShopCard",
    component: _5a3203f8,
    name: "demandDashboard-components-demandShopCard"
  }, {
    path: "/demandListV2/components/demandFilter",
    component: _f2778cbc,
    name: "demandListV2-components-demandFilter"
  }, {
    path: "/firmList/components/data",
    component: _3ff707cf,
    name: "firmList-components-data"
  }, {
    path: "/firmList/components/filter",
    component: _4326bd0e,
    name: "firmList-components-filter"
  }, {
    path: "/firmList/components/infoRow",
    component: _367cc7a6,
    name: "firmList-components-infoRow"
  }, {
    path: "/firmList/components/provinceSelect",
    component: _a7229c3c,
    name: "firmList-components-provinceSelect"
  }, {
    path: "/goodsListV2/components/data",
    component: _79e273ea,
    name: "goodsListV2-components-data"
  }, {
    path: "/goodsListV2/components/filter",
    component: _a9acf55c,
    name: "goodsListV2-components-filter"
  }, {
    path: "/goodsListV2/components/filterRow",
    component: _8d75fb50,
    name: "goodsListV2-components-filterRow"
  }, {
    path: "/Intermediary/components/achievementCard",
    component: _08001d34,
    name: "Intermediary-components-achievementCard"
  }, {
    path: "/Intermediary/components/al-selector",
    component: _1ff19c48,
    name: "Intermediary-components-al-selector"
  }, {
    path: "/Intermediary/components/filter",
    component: _e2ac7ca4,
    name: "Intermediary-components-filter"
  }, {
    path: "/Intermediary/components/kxjsCard",
    component: _642e9eaf,
    name: "Intermediary-components-kxjsCard"
  }, {
    path: "/lasaDemand/components/demandCard",
    component: _48406b43,
    name: "lasaDemand-components-demandCard"
  }, {
    path: "/lasaDemand/components/filter",
    component: _78388b4f,
    name: "lasaDemand-components-filter"
  }, {
    path: "/lasaDemand/components/kxjsCard",
    component: _78ef3524,
    name: "lasaDemand-components-kxjsCard"
  }, {
    path: "/measurement/baseSheshi/largeYiqi",
    component: _25f2be6f,
    name: "measurement-baseSheshi-largeYiqi"
  }, {
    path: "/measurement/baseSheshi/shiyanshi",
    component: _5784b6ee,
    name: "measurement-baseSheshi-shiyanshi"
  }, {
    path: "/measurement/chengguo/guifan",
    component: _43b2082f,
    name: "measurement-chengguo-guifan"
  }, {
    path: "/measurement/chengguo/xianjin",
    component: _ca1feca0,
    name: "measurement-chengguo-xianjin"
  }, {
    path: "/measurement/components/bodyContent",
    component: _06954101,
    name: "measurement-components-bodyContent"
  }, {
    path: "/measurement/components/card",
    component: _71298f14,
    name: "measurement-components-card"
  }, {
    path: "/measurement/components/five",
    component: _a5bbd9d0,
    name: "measurement-components-five"
  }, {
    path: "/measurement/components/four",
    component: _2cec60e8,
    name: "measurement-components-four"
  }, {
    path: "/measurement/components/myPublish",
    component: _ab037666,
    name: "measurement-components-myPublish"
  }, {
    path: "/measurement/components/myPublish3",
    component: _b51fd494,
    name: "measurement-components-myPublish3"
  }, {
    path: "/measurement/components/one",
    component: _a13fcd20,
    name: "measurement-components-one"
  }, {
    path: "/measurement/components/seven",
    component: _3b0b29d2,
    name: "measurement-components-seven"
  }, {
    path: "/measurement/components/six",
    component: _7b7c89ec,
    name: "measurement-components-six"
  }, {
    path: "/measurement/components/three",
    component: _4b6abfb0,
    name: "measurement-components-three"
  }, {
    path: "/measurement/components/two",
    component: _70706b54,
    name: "measurement-components-two"
  }, {
    path: "/measurement/questions/ask",
    component: _7cf0bf04,
    name: "measurement-questions-ask"
  }, {
    path: "/onlineService/components/AiChat",
    component: _102ac768,
    name: "onlineService-components-AiChat"
  }, {
    path: "/onlineService/components/AllFunctions",
    component: _2d5e98b4,
    name: "onlineService-components-AllFunctions"
  }, {
    path: "/onlineService/components/AllFunctionsNew",
    component: _b3b83f6c,
    name: "onlineService-components-AllFunctionsNew"
  }, {
    path: "/onlineService/components/Historical",
    component: _3c262a76,
    name: "onlineService-components-Historical"
  }, {
    path: "/onlineService/components/HList",
    component: _05aa57ac,
    name: "onlineService-components-HList"
  }, {
    path: "/onlineService/components/RelatedWords",
    component: _78886fea,
    name: "onlineService-components-RelatedWords"
  }, {
    path: "/onlineService/components/RightNav",
    component: _917554da,
    name: "onlineService-components-RightNav"
  }, {
    path: "/onlineService/components/SearchBox",
    component: _53163587,
    name: "onlineService-components-SearchBox"
  }, {
    path: "/onlineService/components/SmartMatchResults",
    component: _062f6444,
    name: "onlineService-components-SmartMatchResults"
  }, {
    path: "/onlineService/components/TechnicalManager",
    component: _35a29d88,
    name: "onlineService-components-TechnicalManager"
  }, {
    path: "/onlineService/components/TechnicalManagerNew",
    component: _97261a18,
    name: "onlineService-components-TechnicalManagerNew"
  }, {
    path: "/onlineService/components/TechnicalManagerNew2",
    component: _4d6dd624,
    name: "onlineService-components-TechnicalManagerNew2"
  }, {
    path: "/overall/components/demandCard",
    component: _1efa9ab2,
    name: "overall-components-demandCard"
  }, {
    path: "/roadShow/components/activityCard",
    component: _1d090dd4,
    name: "roadShow-components-activityCard"
  }, {
    path: "/screen/components/areaTopList",
    component: _6fca1d30,
    name: "screen-components-areaTopList"
  }, {
    path: "/screen/components/collegeLeft1",
    component: _8de1948e,
    name: "screen-components-collegeLeft1"
  }, {
    path: "/screen/components/collegeLeft2",
    component: _8dc5658c,
    name: "screen-components-collegeLeft2"
  }, {
    path: "/screen/components/collegeLeft3",
    component: _8da9368a,
    name: "screen-components-collegeLeft3"
  }, {
    path: "/screen/components/collegeMid1",
    component: _f6aa79ec,
    name: "screen-components-collegeMid1"
  }, {
    path: "/screen/components/collegeMid2",
    component: _f68e4aea,
    name: "screen-components-collegeMid2"
  }, {
    path: "/screen/components/collegeMid3",
    component: _f6721be8,
    name: "screen-components-collegeMid3"
  }, {
    path: "/screen/components/collegeRight1",
    component: _59d2e514,
    name: "screen-components-collegeRight1"
  }, {
    path: "/screen/components/collegeRight2",
    component: _59b6b612,
    name: "screen-components-collegeRight2"
  }, {
    path: "/screen/components/collegeRight3",
    component: _599a8710,
    name: "screen-components-collegeRight3"
  }, {
    path: "/screen/components/fieldMid1",
    component: _18889bed,
    name: "screen-components-fieldMid1"
  }, {
    path: "/screen/components/fieldMid3",
    component: _18a4caef,
    name: "screen-components-fieldMid3"
  }, {
    path: "/screen/components/itemMap",
    component: _0c8a1fb3,
    name: "screen-components-itemMap"
  }, {
    path: "/screen/components/itemMap2",
    component: _f65cffe2,
    name: "screen-components-itemMap2"
  }, {
    path: "/screen/components/itemMap3",
    component: _f640d0e0,
    name: "screen-components-itemMap3"
  }, {
    path: "/screen/components/table",
    component: _13200838,
    name: "screen-components-table"
  }, {
    path: "/screen/components/toolTip",
    component: _cd70c6bc,
    name: "screen-components-toolTip"
  }, {
    path: "/screen/components/yzArea",
    component: _6d0ba054,
    name: "screen-components-yzArea"
  }, {
    path: "/screen/directive/dateTime",
    component: _73fbcb91,
    name: "screen-directive-dateTime"
  }, {
    path: "/screen/directive/demandArea",
    component: _ae796158,
    name: "screen-directive-demandArea"
  }, {
    path: "/screen/directive/directives",
    component: _29c3f970,
    name: "screen-directive-directives"
  }, {
    path: "/screen/directive/directivesyz",
    component: _c05cf772,
    name: "screen-directive-directivesyz"
  }, {
    path: "/screen/directive/eight",
    component: _60f1e013,
    name: "screen-directive-eight"
  }, {
    path: "/screen/directive/first",
    component: _4799435c,
    name: "screen-directive-first"
  }, {
    path: "/screen/directive/five",
    component: _758a28cc,
    name: "screen-directive-five"
  }, {
    path: "/screen/directive/four",
    component: _61205eb4,
    name: "screen-directive-four"
  }, {
    path: "/screen/directive/nine",
    component: _6bfc099a,
    name: "screen-directive-nine"
  }, {
    path: "/screen/directive/second",
    component: _719f9d58,
    name: "screen-directive-second"
  }, {
    path: "/screen/directive/seven",
    component: _551517d5,
    name: "screen-directive-seven"
  }, {
    path: "/screen/directive/six",
    component: _f03294c0,
    name: "screen-directive-six"
  }, {
    path: "/screen/directive/ten",
    component: _ed42b6f6,
    name: "screen-directive-ten"
  }, {
    path: "/screen/directive/three",
    component: _54d17ca4,
    name: "screen-directive-three"
  }, {
    path: "/screen/directive/yztotal",
    component: _d46836c2,
    name: "screen-directive-yztotal"
  }, {
    path: "/supplyNew/components/achievementCard",
    component: _76558754,
    name: "supplyNew-components-achievementCard"
  }, {
    path: "/supplyNew/components/demandCard",
    component: _60414596,
    name: "supplyNew-components-demandCard"
  }, {
    path: "/supplyNew/components/filter",
    component: _3e916dc8,
    name: "supplyNew-components-filter"
  }, {
    path: "/supplyNew/components/kxjsCard",
    component: _0edc8efe,
    name: "supplyNew-components-kxjsCard"
  }, {
    path: "/supplyNew/components/serviceCard",
    component: _75490f5a,
    name: "supplyNew-components-serviceCard"
  }, {
    path: "/xianlin/components/myPublish",
    component: _f340e514,
    name: "xianlin-components-myPublish"
  }, {
    path: "/yangzhou/components/myPublish",
    component: _79ff2964,
    name: "yangzhou-components-myPublish"
  }, {
    path: "/yiliDemand/components/demandCard",
    component: _adc86d66,
    name: "yiliDemand-components-demandCard"
  }, {
    path: "/yiliDemand/components/filter",
    component: _1a6de1f6,
    name: "yiliDemand-components-filter"
  }, {
    path: "/yiliDemand/components/headerBar",
    component: _606e5a64,
    name: "yiliDemand-components-headerBar"
  }, {
    path: "/yiliDemand/components/kxjsCard",
    component: _8a508410,
    name: "yiliDemand-components-kxjsCard"
  }, {
    path: "/yiliDemand/newsList/newsDetail",
    component: _32c099bb,
    name: "yiliDemand-newsList-newsDetail"
  }, {
    path: "/measurement/baseSheshi/largeYiqi/:id",
    component: _1aa8ded2,
    name: "measurement-baseSheshi-largeYiqi-id"
  }, {
    path: "/measurement/baseSheshi/shiyanshi/:id",
    component: _2d0f9cd6,
    name: "measurement-baseSheshi-shiyanshi-id"
  }, {
    path: "/measurement/chengguo/guifan/:id",
    component: _17324a57,
    name: "measurement-chengguo-guifan-id"
  }, {
    path: "/measurement/chengguo/xianjin/:id",
    component: _6d54b818,
    name: "measurement-chengguo-xianjin-id"
  }, {
    path: "/technicalContractsRegistration/list/detail/:id?",
    component: _339e99eb,
    name: "technicalContractsRegistration-list-detail-id"
  }, {
    path: "/activityTech/technicalManager/:id",
    component: _5b7d5f25,
    name: "activityTech-technicalManager-id"
  }, {
    path: "/branch/businessIncubation/:id",
    component: _ecbfb33c,
    name: "branch-businessIncubation-id"
  }, {
    path: "/branch/devSearch/:id",
    component: _1ca5172a,
    name: "branch-devSearch-id"
  }, {
    path: "/branch/news/:id",
    component: _fd8273aa,
    name: "branch-news-id"
  }, {
    path: "/branch/technicalAchievements/:id",
    component: _ebade622,
    name: "branch-technicalAchievements-id"
  }, {
    path: "/branch/technicalDemand/:Id",
    component: _abf78994,
    name: "branch-technicalDemand-Id"
  }, {
    path: "/branch/technicalManager/:id",
    component: _19aee730,
    name: "branch-technicalManager-id"
  }, {
    path: "/measurement/expert/:id",
    component: _60779758,
    name: "measurement-expert-id"
  }, {
    path: "/measurement/news1/:id",
    component: _670d9db6,
    name: "measurement-news1-id"
  }, {
    path: "/measurement/news2/:id",
    component: _095be692,
    name: "measurement-news2-id"
  }, {
    path: "/technicalContractsRegistration/download/:id?",
    component: _fa54a476,
    name: "technicalContractsRegistration-download-id"
  }, {
    path: "/technicalContractsRegistration/list/:id?",
    component: _12eeacdb,
    name: "technicalContractsRegistration-list-id"
  }, {
    path: "/activityTech/:id",
    component: _31853bc0,
    name: "activityTech-id"
  }, {
    path: "/antincp/:id",
    component: _48bb68c4,
    name: "antincp-id"
  }, {
    path: "/collegeNews/:id",
    component: _3eb7e3d6,
    name: "collegeNews-id"
  }, {
    path: "/expert/:id",
    component: _b49616b6,
    name: "expert-id"
  }, {
    path: "/laboratory/:id",
    component: _70e8012e,
    name: "laboratory-id"
  }, {
    path: "/lasaDemand/:id?",
    component: _50a9a129,
    name: "lasaDemand-id"
  }, {
    path: "/manageList/:id",
    component: _41aa291e,
    name: "manageList-id"
  }, {
    path: "/news/:id",
    component: _4a6af364,
    name: "news-id"
  }, {
    path: "/overall/:id?",
    component: _43211e58,
    name: "overall-id"
  }, {
    path: "/publicity/:id",
    component: _3e9cf9b0,
    name: "publicity-id"
  }, {
    path: "/xianlinActivity/:Id",
    component: _7e7c3f66,
    name: "xianlinActivity-Id"
  }, {
    path: "/xianlinAgencyList/:Id",
    component: _a8d8b67e,
    name: "xianlinAgencyList-Id"
  }, {
    path: "/xianlinGnyz/:Id",
    component: _5d336ff4,
    name: "xianlinGnyz-Id"
  }, {
    path: "/xianlinManageList/:id",
    component: _78412a01,
    name: "xianlinManageList-id"
  }, {
    path: "/xianlinNews/:id",
    component: _0b60ad71,
    name: "xianlinNews-id"
  }, {
    path: "/xianlinNotice/:id",
    component: _0997f9b6,
    name: "xianlinNotice-id"
  }, {
    path: "/xianlinPresentationDemand/:Id",
    component: _b23948fa,
    name: "xianlinPresentationDemand-Id"
  }, {
    path: "/xianlinPtzt/:Id",
    component: _0eb01ffc,
    name: "xianlinPtzt-Id"
  }, {
    path: "/xianlinYqgx/:Id",
    component: _7641a272,
    name: "xianlinYqgx-Id"
  }, {
    path: "/yangzhouActivity/:Id",
    component: _289c809f,
    name: "yangzhouActivity-Id"
  }, {
    path: "/yangzhouManageList/:Id",
    component: _1d59e9f3,
    name: "yangzhouManageList-Id"
  }, {
    path: "/yangzhouNews/:id",
    component: _602c46c3,
    name: "yangzhouNews-id"
  }, {
    path: "/yangzhouPresentationDemand/:Id",
    component: _27373d55,
    name: "yangzhouPresentationDemand-Id"
  }, {
    path: "/",
    component: _e542f99c,
    name: "index"
  }, {
    path: "/technicalContractsRegistration/index",
    redirect: "/technicalContractsRegistration"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
